<template>
  <FormSubmitPopup
    :title="title"
    v-model="value"
    :rightMethod="onSubmitted"
    :rightButtonDisabled="isSubmitEEILoading || isWaitEeiLoading"
    @popupClose="$emit('input', false)"
    :rightButtonText="$t('submit')"
    :isDisabledValidate="true"
    ref="formPopup"
    hasAlert
    large
  >
    <template v-slot:input>
      <v-container class="compact" fluid>
        <v-layout row>
          <v-flex xs12>
            <v-autocomplete
              hide-details
              :items="labelTemplates"
              return-object
              :label="$t('template')"
              item-text="name"
              v-model="selectedLabelTemplate"
              @change="applyLabelTemplate"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout class="title compact-layout" align-baseline justify-space-between>
          <v-flex>
            <v-card width="100%">
              <v-card-text>
                <v-layout align-baseline>
                  <v-flex xs3>
                    {{ $t('electronicExportInformation') }}:
                  </v-flex>
                  <v-flex xs3>
                    <v-menu
                      offset-y
                      :close-on-content-click="false"
                      v-model="menuItn"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          label="ITN"
                          persistent-hint
                          :hint="$t('labelITNDesc')"
                          v-model="itn"
                          autocomplete="NoAutocomplete"
                          @click.stop="on.click"
                        >
                          <template v-slot:append>
                            <v-btn color="primary" small flat @click.stop="getAddressFromItn" :disabled="!itn">{{ $t('importInfo') }}</v-btn>
                          </template>
                        </v-text-field>
                      </template>
                      <v-list v-if="recentItns && recentItns.length">
                        <v-list-tile
                          v-for="item in recentItns"
                          :key="item.requestId"
                          @click.stop="() => onSelectItn(item)"
                        >
                          <v-list-tile-content>
                            <v-list-tile-title>{{ item.requestId }} - {{ item.itn || 'pending' }}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-flex>
                  <v-flex xs1>
                    <v-tooltip top>
                      <template v-slot:activator="{on}">
                        <div v-on="on">
                          <LoaderButton
                            buttonIcon
                            flat
                            :promiseAwait="getEeiStatus"
                          >
                            <template v-slot:icon>
                              <v-icon>refresh</v-icon>
                            </template>
                          </LoaderButton>
                        </div>
                      </template>
                      {{ $t('getSelectedITN') }}
                    </v-tooltip>
                  </v-flex>
                  <v-flex xs2>
                    <v-checkbox
                      class="checkbox"
                      v-model="isCommercialInvoice"
                      :label="$t('commercialInvoice')"></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex md6>
            <v-card width="100%">
              <v-card-text>
                <v-layout align-baseline>
                  <v-flex class="title" md3>{{ $t('sender') }}: </v-flex>
                  <v-flex md4>
                    <vite-autocomplete
                      hide-details
                      :items="fromAddress"
                      name="address-template-name"
                      return-object
                      :label="$t('addressName')"
                      v-model="fromTemplate"
                      item-text="siteName"
                      item-value="key"></vite-autocomplete>
                  </v-flex>
                  <v-flex md2>
                    <v-checkbox hide-details :label="$t('save')"  class="checkbox" v-model="isSaveFrom"></v-checkbox>
                  </v-flex>
                  <v-flex md3 v-if="!isSaveFrom">
                    <v-btn flat color="primary" @click="toggleParseAddress('isShowFromParseAddress', 'parseFormAddress', from)">{{$t('parseAddress')}}</v-btn>
                  </v-flex>
                  <v-flex md3 v-else>
                    <v-text-field
                      hide-details
                      :label="$t('addressName')"
                      v-model.trim="from.siteName"
                      v-if="isSaveFrom"
                      :rules="[ fieldIsRequired('Site name'),  v => v === to.siteName && isSaveTo ? $t('siteNameIsSameAsToSite') : true]"
                      class="required_field"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout v-if="isShowFromParseAddress">
                  <v-textarea
                    :label="$t('fullAddress')"
                    v-model.trim="parseFormAddress"
                    outline
                    rows="3"
                    hide-details
                  >
                  </v-textarea>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('fullName')"
                          v-model.trim="from.fullName"
                          :rules="[ fieldIsRequired('Full name'), fieldCharLimit('Full name', 35) ]"
                          class="required_field"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <v-layout justify-space-between>
                          <v-flex v-bind="{ xs7: currentShippingService.isSupportFromExt, xs12: !currentShippingService.isSupportFromExt }">
                            <v-text-field
                              hide-details
                              class="required_field"
                              :rules="[fieldIsRequired('Phone')]"
                              :label="$t('phone')"
                              v-model.trim="from.phone"
                            ></v-text-field>
                          </v-flex>
                          <v-flex v-if="currentShippingService.isSupportFromExt" xs4>
                            <v-text-field
                              hide-details
                              :label="$t('extension')"
                              v-model.trim="from.extension"
                              :rules="[fieldCharLimit('extension', 6)]"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      hide-details
                      :rules="[fieldCharRange($t('companyName'),3, 35)]"
                      :label="$t('companyName')"
                      v-model.trim="from.company"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-text-field
                      hide-details
                      :label="`${$t('address')} 1`"
                      v-model.trim="from.address1"
                      :rules="[fieldIsRequired('Address'), fieldCharLimit('Address1', 50)]"
                      class="required_field"></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      hide-details
                      :label="`${$t('address')} 2`"
                      :rules="[fieldCharLimit('Address2', 50)]"
                      v-model.trim="from.address2"
                      ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('city')"
                          v-model.trim="from.city"
                          :rules="[fieldIsRequired('City')]"
                          class="required_field"
                          ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <vite-autocomplete
                          hide-details
                          :items="states"
                          v-model="from.state"
                          :label="$t('state')"
                          :rules="[fieldIsRequired('State')]"
                          class="required_field"
                        >
                          <template v-slot:item="data">
                            <template>
                              <v-list-tile-content>
                                <v-list-tile-title :id="data.item">
                                  {{data.item}}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </template>
                          </template>
                        </vite-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      hide-details
                      :label="$t('zipCode')"
                      v-model.trim="from.zipCode"
                      :rules="[fieldIsRequired('Zip code')]"
                      class="required_field"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5>
                        <v-layout>
                          <v-flex xs3>
                            <v-select
                              hide-details
                              :items="[{text: 'EIN', value: 'E'}, {text: 'SSN', value: 'S'}]"
                              v-model="fromPartyIdType"
                              ></v-select>
                          </v-flex>
                          <v-flex xs9>
                            <v-text-field
                              hide-details
                              label="EIN/SSN"
                              :rules="[partyIdValidator]"
                              v-model.trim="from.partyId"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('email')"
                          v-model.trim="from.email"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs4>
                    <vite-autocomplete
                      hide-details
                      :items="[{
                        name: $t('unitedStates'),
                        value: 'US'
                      }]"
                      item-text="name"
                      item-value="value"
                      v-model="from.countryCode"
                      :label="$t('country')"></vite-autocomplete>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md6>
            <v-card width="100%">
              <v-card-text>
                <v-layout align-baseline>
                  <v-flex class="title" md3>{{ $t('recipient') }}: </v-flex>
                  <v-flex md4>
                    <vite-autocomplete
                      hide-details
                      :items="addresses"
                      return-object
                      :label="$t('addressName')"
                      v-model="toTemplate"
                      item-text="siteName"
                      item-value="siteName"></vite-autocomplete>
                  </v-flex>
                  <v-flex md2>
                    <v-checkbox hide-details :label="$t('save')" v-model="isSaveTo" class="checkbox"></v-checkbox>
                  </v-flex>
                  <v-flex md3 v-if="!isSaveTo">
                    <v-btn flat color="primary" @click="toggleParseAddress('isShowToParseAddress', 'parseToAddress', to)">{{$t('parseAddress')}}</v-btn>
                  </v-flex>
                  <v-flex md3 v-else>
                    <v-text-field
                      hide-details
                      :label="$t('addressName')"
                      v-model.trim="to.siteName"
                      v-if="isSaveTo"
                      :rules="[ fieldIsRequired('Site name'),  v => v === from.siteName && isSaveFrom? $t('siteNameIsSameAsToSite') : true]"
                      class="required_field"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout v-if="isShowToParseAddress">
                  <v-textarea
                    :label="$t('fullAddress')"
                    v-model.trim="parseToAddress"
                    outline
                    rows="3"
                    hide-details
                  >
                  </v-textarea>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('fullName')"
                          v-model.trim="to.fullName"
                          :rules="[ fieldIsRequired('Full name'), fieldCharLimit('Full name', 35) ]"
                          class="required_field"
                        />
                      </v-flex>
                      <v-flex xs5>
                        <v-layout justify-space-between>
                          <v-flex v-bind="{ xs7: currentShippingService.isSupportToExt, xs12: !currentShippingService.isSupportToExt }">
                            <v-text-field
                              hide-details
                              :label="$t('phone')"
                              class="required_field"
                              :rules="[fieldIsRequired('Phone')]"
                              v-model.trim="to.phone"
                            ></v-text-field>
                          </v-flex>
                          <v-flex v-if="currentShippingService.isSupportToExt" xs4>
                            <v-text-field
                              hide-details
                              :label="$t('extension')"
                              v-model.trim="to.extension"
                              :rules="[fieldCharLimit('extension', 6)]"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      hide-details
                      :rules="[fieldCharRange($t('companyName'),3, 35)]"
                      :label="$t('companyName')"
                      v-model.trim="to.company"
                    />
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-text-field
                      hide-details
                      :label="`${$t('address')} 1`"
                      v-model.trim="to.address1"
                      :rules="[fieldIsRequired('Address'), fieldCharLimit('address', 50)]"
                      class="required_field"></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      hide-details
                      :label="`${$t('address')} 2`"
                      :rules="[fieldCharLimit('Address2', 50)]"
                      v-model.trim="to.address2"
                      ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('city')"
                          v-model.trim="to.city"
                          :rules="[fieldIsRequired('City')]"
                          class="required_field"
                          ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('state')"
                          v-model.trim="to.state"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <v-layout justify-space-around align-baseline>
                      <v-flex>
                        <v-text-field
                          hide-details
                          :label="$t('zipCode')"
                          v-model.trim="to.zipCode"></v-text-field>
                      </v-flex>
                      <v-flex xs2>
                        <v-tooltip top>
                          <template v-slot:activator="{on}">
                            <v-btn :disabled="googleMapDisabled" icon flat v-on="on" color="primary" @click.stop="goToGoogleMapLink" small><v-icon>location_on</v-icon></v-btn>
                          </template>
                          <span> {{ $t('googleMap') }}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5>
                        <v-layout>
                          <v-flex xs3>
                            <v-select
                              hide-details
                              :items="[{text: 'EIN', value: 'E'}, {text: 'SSN', value: 'S'}]"
                              v-model="toPartyIdType"
                              ></v-select>
                          </v-flex>
                          <v-flex xs9>
                            <v-text-field
                              hide-details
                              label="EIN/SSN"
                              v-model.trim="to.partyId"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('email')"
                          v-model.trim="to.email"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <vite-autocomplete
                      hide-details
                      :items="countryCodeArray"
                      item-text="name"
                      item-value="value"
                      v-model="to.countryCode"
                      :label="$t('country')"
                      :rules="[fieldIsRequired('Country')]"
                      class="required_field"></vite-autocomplete>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row v-if="hasHazmatFeatures && isLabelServiceSupportDangerousGoods">
          <v-flex>
            <v-card width="100%">
              <v-card-text>
                <HazardousCommodities
                  :dangerousGoods.sync="dangerousGoods"
                  :dryIceWeight.sync="dryIceDetail.weight"
                  :dryIceUnit.sync="dryIceDetail.unit"
                  :filterItems="['', 'LITHIUM_BATTERY']"
                  :isPrintSafetyDocument.sync="isPrintSafetyDocument"
                  :signatureCode.sync="signatureCode"
                  ref="HazardousCommodities"
                />
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <!-- <v-layout row> -->
          <!-- <v-flex> -->
            <v-card width="100%">
              <v-card-text>
                <EeiPackageWidget
                  ref="EeiPackageWidget"
                  :packages.sync="packages"
                  :noteMemoSignature='noteMemoSignature'
                  :shipmentPurpose='shipmentPurpose'
                  :shippingService.sync="shippingService"
                  :bookingConfirmationNumber='bookingConfirmationNumber'
                  :isAutoGetRate="true"
                  :autoGetRateShippingService="autoGetRateShippingService"
                  :isGetRateAction="isGetRateAction"
                  :dangerousGoods="dangerousGoods"
                  @changeAutoGetRate="e => isAutoGetRate = e"
                  @selectTemplate="selectTemplate"
                  @changeShippingService="changeShippingService"
                  :isEeiMode="isEeiMode"
                  @clearDangerousGoods="clearDangerousGoods"
                />
              </v-card-text>
            </v-card>
          <!-- </v-flex> -->
        <!-- </v-layout> -->

        <v-layout row>
          <v-flex>
            <v-card width="100%">
              <v-card-text>
                <v-layout class="title" align-baseline justify-space-between>
                  <v-flex xs2>
                    {{ $t('billingDetails') }}:
                  </v-flex>
                  <v-flex md2>
                    <vite-autocomplete
                      hide-details
                      :items="[{
                        text: $t('sender'),
                        value: 'sender'
                      }]"
                      readonly
                      item-value="value"
                      item-text="text"
                      v-model="billingTransportationTo"
                      :label="$t('billingTransportationTo')"></vite-autocomplete>
                  </v-flex>
                  <v-flex xs2>
                    <vite-autocomplete
                      hide-details
                      :items="[{
                        text: $t('recipient'),
                        value: 'RECIPIENT'
                      }
                      ]"
                      item-value="value"
                      item-text="text"
                      v-model="dutiesPayor"
                      :label="$t('dutiesPayor')"></vite-autocomplete>
                  </v-flex>
                  <v-flex xs2>
                  </v-flex>
                  <v-flex xs2>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row v-if="!!isFedexCarrier">
          <v-flex>
            <v-card width="100%">
              <v-card-text>
                <v-layout class="title" align-baseline justify-space-between style="min-height: 56px;">
                  <v-flex xs1>
                    ETD:
                  </v-flex>
                  <v-flex grow>
                    <v-layout align-center class="etd-checkbox-container">
                      <v-checkbox
                        class="checkbox"
                        v-model="isEnabledETD"
                        :label="$t('ETDLabel')"
                        hide-details>
                      </v-checkbox>
                      <v-tooltip top max-width="300px">
                        <template slot="activator">
                          <v-icon
                            small
                            color="primary"
                            style="cursor: pointer;">
                            help_outline
                          </v-icon>
                        </template>
                        <div style="white-space: normal; line-height: 1.4;">
                          {{ $t('ETDInfo') }}
                        </div>
                      </v-tooltip>
                    </v-layout>
                </v-flex>
                  <v-flex md8 xs8>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout row class="compact-layout">
          <v-flex>
            <v-form ref="commodityForm" >
              <v-card class="compact-card" width="100%" v-if="!isEnableEEI">
                <v-card-text class="compact-card-text">
                  <v-layout class="title compact-layout" align-baseline justify-start>
                      {{ $t('commodityInfo') }}:
                    <v-flex xs3 ml-4 v-if="!isCommodityUnchangeable">
                      <v-layout>
                        <v-flex xs6>
                          <v-combobox
                            hide-details
                            :label="$t('commodityTemplate')"
                            :items="commodityTemplates"
                            item-text="name"
                            item-value="key"
                            clearable
                            @change="onSelectCommodityTemplate"
                          ></v-combobox>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            ref="newTemplateNameInput"
                            hide-details
                            :label="$t('newTemplateName')"
                            v-model.trim="newTemplateName"
                            @keyup.enter="saveCommodityTemplate"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" @click="saveCommodityTemplate" :loading="isSavingTemplate" :disabled="isSavingTemplate">
                                <v-icon>save</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('saveAsTemplate') }}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex class="red--text font-weight-bold text-xs-right" v-if="commodityErrorMessage">
                      {{ commodityErrorMessage }}
                    </v-flex>
                  </v-layout>
                  <v-data-table
                    :headers="commodityHeaders"
                    :items="commodities"
                    hide-actions
                    class="elevation-2 mt-2"
                  >
                    <template v-slot:headerCell="props">
                      <span v-if="props.header.value === 'action'">
                        <v-tooltip top>
                          <template v-slot:activator="tooltip">
                            <div v-on="tooltip.on">
                              <v-btn color="primary" flat small icon :disabled="isCommodityUnchangeable" @click="addEmptyCommodity"><v-icon>add</v-icon></v-btn>
                            </div>
                          </template>
                          {{ $t('add') }}
                        </v-tooltip>
                      </span>
                      <span v-else>{{ props.header.text }}</span>
                    </template>
                    <template v-slot:items="props">
                      <tr
                        class="commodity-row"
                        :class="{'editing': editingRowIndex === props.index}"
                        @click="editRow(props.index, $event)"
                        @mouseleave="onRowMouseLeave"
                      >
                      <td class="text-xs-center">
                        <v-tooltip top>
                          <template v-slot:activator="{on}">
                            <v-btn color="error" flat small icon v-on="on" @click="deleteCommodity(props.index)" :disabled="commodities.length === 1 || isCommodityUnchangeable"><v-icon>delete</v-icon></v-btn>
                          </template>
                          <span>{{ $t('delete') }}</span>
                        </v-tooltip>
                        <!-- <v-tooltip top>
                          <template v-slot:activator="{on}">
                            <v-btn icon v-on="on" :disabled="props.item.isLoading" :loading="props.item.isLoading" @click="saveCommodityProfile(props.item)">
                              <v-icon color="primary">article</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('saveCommodityTemplate') }}</span>
                        </v-tooltip> -->
                      </td>
                      <td class="text-xs-left">
                        <v-layout row>
                          <v-autocomplete
                            class="table-item"
                            style="max-width: 200px;"
                            :value="props.item.selectedCommodity"
                            :items="mergedCommoditiesList"
                            item-text="scheduleBDescription"
                            item-value="scheduleBDescription"
                            :filter="customCommodityFilter"
                            clearable
                            :label="$t('commodity')"
                            :placeholder="$t('commodities')"
                            @change="onComboboxChangeByCommodities($event, props.index)"
                            @input="onComboboxChangeByCommodities($event, props.index)"
                            :rules="[fieldIsRequired($t('commodity'))]"
                            :disabled="editingRowIndex !== props.index || isCommodityUnchangeable"
                            return-object
                          >
                            <template v-slot:item="data">
                              <v-list-tile-content style="max-width: 300px; white-space: normal;">
                                <v-list-tile-title style="white-space: normal; word-wrap: break-word;">{{ data.item.scheduleBDescription || data.item.description }}</v-list-tile-title>
                                <v-list-tile-sub-title style="white-space: normal; word-wrap: break-word;">
                                  Code: {{ data.item.scheduleBCode }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                            </template>
                            <template v-slot:no-data>
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    {{ $t('noDataAvailable') }}
                                  </v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </template>
                          </v-autocomplete>
                          <v-text-field
                            class="table-item"
                            style="max-width: 250px;"
                            v-model.trim="props.item.scheduleBDescription"
                            :label="$t('description')"
                            :placeholder="$t('description')"
                            :rules="[fieldIsRequired($t('description'))]"
                            :disabled="editingRowIndex !== props.index"
                          ></v-text-field>
                        </v-layout>
                      </td>
                      <td class="text-xs-left">
                        <v-layout row>
                        <v-autocomplete
                          class="table-item required_field"
                          v-model="props.item.countryOfOrigin"
                          :items="countryCodeArray"
                          :label="$t('countryOfOrigin')"
                          item-text="name"
                          item-value="value"
                          :rules="[fieldIsRequired($t('countryOfOrigin'))]"
                          :disabled="editingRowIndex !== props.index || (isCommodityUnchangeable && props.item.countryOfOrigin === 'US')"
                        ></v-autocomplete>
                          <v-text-field
                          class="table-item required_field"
                          v-model.trim="props.item.harmonizedCode"
                          @input="onHarmonizedCodeInput(props.item)"
                          :rules="[validateHsCode]"
                          :class="{'required_field': isHsCodeRequired(props.item)}"
                          :disabled="editingRowIndex !== props.index"
                        ></v-text-field>
                        </v-layout>
                      </td>

                      <td class="text-xs-left">
                        <v-text-field
                          :rules="[
                            fieldIsRequired(),
                            fieldIsInteger(),
                            fieldIsOverZero()
                          ]"
                          class="required_field pt-0 table-item qty_unit_filed"
                          v-model.number="props.item.quantity"
                          :label="$t('quantity')"
                          @input="onQuantityInput(props.item)"
                          :disabled="editingRowIndex !== props.index || isCommodityUnchangeable"
                          @click.native.stop
                        >
                          <template
                            slot="append-outer"
                          >
                            <v-autocomplete
                              class="qty_unit required_field"
                              :items="getCommodityUnitItems(props.item)"
                              v-model="props.item.selectedUnit"
                              :rules="[fieldIsRequired($t('unit'))]"
                              item-text="text"
                              item-value="key"
                              :label="$t('unit')"
                              :disabled="editingRowIndex !== props.index || isCommodityUnchangeable"
                            ></v-autocomplete>
                          </template>
                        </v-text-field>
                      </td>
                      <td class="text-xs-left" v-if="hasCommodityQty2">
                        <v-text-field
                          v-if="isShowQty2(props.item)"
                          :rules="[
                            fieldIsRequired(),
                            fieldIsInteger(),
                            fieldIsOverZero()
                          ]"
                          class="required_field pt-0 table-item qty_unit_filed"
                          v-model.number="props.item.quantity2"
                          :label="$t('quantity')"
                          :disabled="editingRowIndex !== props.index"
                          @click.native.stop
                        >
                          <template
                            slot="append-outer"
                          >
                            <v-autocomplete
                              class="qty_unit required_field"
                              :items="inShowUnit2List"
                              v-model="props.item.quantity2Units"
                              :rules="[fieldIsRequired($t('unit'))]"
                              item-text="text"
                              item-value="key"
                              :label="$t('unit')"
                              :disabled="editingRowIndex !== props.index"
                            ></v-autocomplete>
                          </template>
                        </v-text-field>
                          <v-text-field
                          v-if="!isShowQty2(props.item)"
                          :rules="[
                            fieldIsRequired(),
                            fieldIsInteger(),
                            fieldIsOverZero()
                          ]"
                          class="required_field pt-0 table-item qty_unit_filed"
                          :label="$t('quantity')"
                          disabled
                          @click.native.stop
                        >
                          <template
                            slot="append-outer"
                          >
                            <v-autocomplete
                              class="qty_unit required_field"
                              :items="inShowUnit2List"
                              :rules="[fieldIsRequired($t('unit'))]"
                              item-text="text"
                              item-value="key"
                              disabled
                              :label="$t('unit')"
                            ></v-autocomplete>
                          </template>
                        </v-text-field>
                      </td>
                      <td class="text-xs-left">
                        <v-text-field
                          :label="$t('price')"
                          class="table-item required_field"
                          v-model.number="props.item.price"
                          @input="onPriceInput(props.item)"
                          prefix="$"
                          :rules="[fieldIsRequired($t('price')), fieldIsOverZero($t('price'))]"
                          :disabled="editingRowIndex !== props.index || isCommodityUnchangeable"
                        ></v-text-field>
                      </td>
                      <td class="text-xs-left">
                        <v-text-field
                          :label="$t('customsValue')"
                          class="table-item required_field"
                          :value="props.item.customsValue"
                          prefix="$"
                          :disabled="true"
                        ></v-text-field>
                      </td>
                      <td class="text-xs-left">
                        <v-text-field
                          :label="$t('weight')"
                          class="table-item required_field"
                          v-model.number="props.item.commodityWeight"
                          :suffix="isMeasurementMetric ? 'kg' : 'Lbs'"
                          :rules="[fieldIsRequired($t('weight')), fieldIsOverZero($t('weight'))]"
                          :disabled="editingRowIndex !== props.index || isCommodityUnchangeable"
                        ></v-text-field>
                      </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-form>
          </v-flex>

        </v-layout>
        <v-layout column class="compact-layout">
          <v-flex>
            <v-layout justify-end align-baseline>
              <span class="mb-2 font-weight-bold text-xs-right" style="font-size: 16px; background-color: yellow;">
                Rate does not include duties & taxes, clearance entry fees or other import fees.
              </span>
              <v-flex xs7>
                <v-layout align-baseline>
                  <v-flex md2><v-btn color="primary" @click.stop="getRate">{{ $t('getRate') }}</v-btn></v-flex>
                  <v-flex v-if="isAutoGetRate" md3 mr-5>
                    <span>{{  $t('selectedShippingService') + ': ' }}</span>
                    <span class="font-weight-black">{{ displayRate.serviceDescription }}</span>
                  </v-flex>
                  <v-flex md9>
                    <v-layout>
                      <v-flex md2 v-if="isLoadingRates">
                        <v-progress-circular
                          indeterminate
                          color="primary"></v-progress-circular>
                      </v-flex>
                      <v-flex md10 v-else>
                        <v-layout row no-wrap text-xs-center>
                          {{ $t('baseCharge') }}: $
                          <v-tooltip top>
                            <template v-slot:activator="tooltip">
                              <span v-on="tooltip.on">
                                {{ displayRate.rate || '----' }}
                              </span>
                            </template>
                            {{displayRate.originBaseCharge ? (Math.round(100*(displayRate.originBaseCharge - displayRate.rate)/displayRate.originBaseCharge)+1) + '% off' : '---'}}
                          </v-tooltip>
                          <span v-if="displayRate.surcharge">
                            &nbsp;&nbsp;
                            {{ $t('surcharge') }}: $ {{ displayRate.surcharge === null ? '----' : displayRate.surcharge }}
                          </span>
                          <small v-if="displayRate.hasResidentialCheck" style="color: blue;">{{
                            $t(displayRate.isResidential ? "residential" : 'commercial')
                          }}</small>
                          <span v-if="displayRate.surcharge">
                            &nbsp;&nbsp;
                            {{ $t('total') }}: $ {{ displayRate.rate ? toMoney(displayRate.rate + displayRate.surcharge) : '----' }}
                          </span>
                          &nbsp;&nbsp;&nbsp;
                          <span v-if="displayRate.estimatedDelivery && displayRate.estimatedDelivery !== 'N/A' && !['xs', 'sm', 'md'].includes($vuetify.breakpoint.name)">
                            {{ $t('estDelivery') }}: {{ formatEstDeliveryDate(displayRate.estimatedDelivery) }}
                          </span>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex md2 v-if="rates.length > 1 && !isLoadingRates" class="subheading font-weight-bold">
                    <!-- more Rates -->
                    <v-menu
                      v-model="moreRatesToggle"
                      :close-on-content-click="false"
                      :nudge-width="200"
                      offset-x
                    >

                      <template v-slot:activator="{ on }">
                        <v-btn
                          dark
                          color="primary"
                          flat
                          v-on="on"
                        > {{ $t('moreRates') }}
                        </v-btn>
                      </template>

                      <v-card>
                        <v-card-text>
                          <v-data-table
                            :headers="[
                              { text: $t('service'), align: 'left', sortable: false, value: 'serviceType' },
                              { text: `${$t('baseCharge')} ($)`, align: 'left', sortable: false, value: 'rate' },
                              { text: `${$t('surcharge')} ($)`, align: 'left', sortable: false, value: 'surcharge'},
                              { text: `${$t('total')} ($)`, align: 'left', sortable: false, value: 'total'},
                              { text: $t('estDelivery'), align: 'left', sortable: false, value: ''}
                            ]"
                            :items="rates"
                            hide-actions
                          >
                            <template v-slot:items="{ item }">
                              <td ><a linkify @click="switchMoreRateServiceType(item)">{{ item.serviceDescription }}</a></td>
                              <template v-if="item.message">
                                <td colspan="4">{{item.message}}</td>
                              </template>
                              <template v-else>
                                <td>{{ item.rate }}</td>
                                <td>{{ item.surcharge }}</td>
                                <td>{{ item.total }}</td>
                                <td>
                                  {{ formatEstDeliveryDate(item.estimatedDelivery) }}
                                </td>
                              </template>
                            </template>
                          </v-data-table>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" flat @click="moreRatesToggle = false" >Close</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout v-if="errorMessage">
              <v-flex class="red--text font-weight-bold text-xs-right">
                {{errorMessage}}
              </v-flex>
            </v-layout>
            <v-layout v-if="Object.keys(warningMessages).length" justify-end>
              <span class="font-weight-bold text-xs-right" style="background-color: yellow;">
                {{Object.values(warningMessages).join(', ')}}
              </span>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog v-model="isWaitEeiLoading" fullscreen full-width>
      <v-container
        fluid
        fill-height
        style="background-color: rgba(255, 255, 255, 0.75)"
      >
        <v-layout column justify-center align-center>
          <v-progress-circular indeterminate color="primary" size="50" width="5">
          </v-progress-circular>
          <div class="mt-4 text-h6">{{ $t('pleaseWait30Seconds') }}</div>
          <div class="mt-2 caption">{{ $t('doNotCloseWindowMessage') }}</div>
        </v-layout>
      </v-container>
    </v-dialog>
    </template>
    <template v-slot:control1 = "{ loaderButtonError }">
      <LoaderButton
        :buttonText="$t('submitEEI')"
        :promiseAwait="showEEIPopup"
        :loading="isSubmitEEILoading"
        :disabled="isSubmitEEILoading || isCommodityUnchangeable"
        @loaderButtonError="loaderButtonError"
        class="ml-3"
        >
        <template slot="icon">
          <v-icon v-if="isWaitEeiLoading" dark class="mx-2 loading"
            >hourglass_empty</v-icon
          >
        </template>
      </LoaderButton>
    </template>

  </FormSubmitPopup>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import EeiPackageWidget from './EeiPackageWidget'
import { timeTools, checkRules, cloneDeep, toMoney, gotoGoogleMap, measurementTools, calculateQtyMethod, commodityTools, getRandomIdByTime, toPickerDateString } from '@/utils/tools'
import CommodityWidget from './CommodityWidget'
import LoaderButton from './LoaderButton'
import HazardousCommodities from './HazardousCommodities'
import { mapGetters } from 'vuex'

const addressArr = [
  ['fullName', 'phone', 'company'],
  ['address1', 'address2'],
  ['city', 'state', 'zipCode'],
  ['partyId', 'email', 'countryCode', 'partyIdType']
]

export default {
  name: 'LabelCreatePopup',
  components: {
    FormSubmitPopup,
    EeiPackageWidget,
    CommodityWidget,
    LoaderButton,
    HazardousCommodities
  },
  mixins: [
    checkRules,
    timeTools,
    measurementTools,
    calculateQtyMethod,
    commodityTools
  ],
  data () {
    return {
      title: this.$t('createExportFromUSLabel'),
      packaging: '',
      signature: '',
      menu: false,
      newSenderName: '',
      from: {
        address1: '',
        city: '',
        state: '',
        zipCode: '',
        countryCode: 'US',
        partyId: '',
        partyIdType: 'E'
      },
      fromTemplate: {},
      to: {
        address1: '',
        city: '',
        state: '',
        zipCode: '',
        partyId: '',
        partyIdType: 'E'
      },
      toTemplate: {},
      rate: null,
      surcharge: null,
      insuredValue: 0,
      isLoadingRates: false,
      isSaveFrom: false,
      isSaveTo: false,
      quantity: 1,
      memo: '',
      note: '',
      errorMessage: '',
      warningMessages: {},
      name: '',
      selectedLabelTemplate: null,
      hasAppliedDefaultLabelTemplate: false,
      shouldAutoApplyDefaultLabelTemplate: true,
      rates: [],
      moreRatesToggle: false,
      shippingService: '',
      autoGetRateShippingService: '',
      packages: [],
      requestIdCache: '',
      isUseCompanySignatureOnFile: false,
      isOriginatorShipperDiff: false,
      isRecipientNotImporter: false,
      termsOfSale: '',
      isUseCompanyLetterheadOnFile: false,
      isProFormaInvoice: false,
      isCommercialInvoice: true,
      itn: '',
      dutiesPayor: 'RECIPIENT',
      billingTransportationTo: 'sender',
      commodities: [],
      recentItns: [],
      menuItn: false,
      noteMemoSignature: {},
      shipmentPurpose: '',
      bookingConfirmationNumber: '',
      isSupportHazmat: false,
      dangerousGoods: '',
      dryIceDetail: {
        unit: '',
        weight: ''
      },
      isPrintSafetyDocument: true,
      signatureCode: null,
      isAutoGetRate: false,
      isGetRateAction: true,
      isShowFromParseAddress: false,
      parseFormAddress: '',
      isShowToParseAddress: false,
      parseToAddress: '',
      isAddingNewCommodity: false,
      commodityErrorMessage: '',
      newCommodity: {
        exportInformationCode: 'OS',
        licenseExceptionSymbol: 'C33',
        countryOfOrigin: 'US',
        scheduleBCode: '',
        customsValue: 0,
        commodityWeight: 0,
        quantity: 1,
        scheduleBDescription: 'Commodity Desc',
        harmonizedCode: ''
      },
      exportInformationCodes: ['OS', 'NLR', 'EAR99', 'ECCN'],
      selectedCommodity: {},
      isSaveCommodityProfile: false,
      searchedCommodities: [],
      profileNameDialog: false,
      commodityToSave: null,
      profileName: '',
      searchText: '',
      menuProfile: false,
      commoditySearchText: '',
      editingRowIndex: -1,
      newTemplateName: '',
      isSavingTemplate: false,
      eeiInfoItems: [],
      isEnableEEI: false,
      isSubmitEEILoading: false,
      isSubmitEEIPopup: false,
      editingEeiIndex: -1,
      eeiEditItems: [],
      isEeiMode: false,
      countryOfOriginList: [{
        name: this.$t('domesticOrigin'),
        value: 'D'
      }, {
        name: this.$t('foreignOrigin'),
        value: 'F'
      }],
      selectedLetterhead: null,
      isEnabledETD: true,
      notAllowedCountries: [
        'AO',
        'AW',
        'BS',
        'BD',
        'BQ',
        'VG',
        'BN',
        'KH',
        'KY',
        'CW',
        'DJ',
        'DO',
        'TL',
        'EG',
        'SV',
        'GH',
        'GP',
        'GT',
        'HN',
        'JO',
        'KE',
        'KW',
        'LA',
        'LS',
        'MG',
        'MT',
        'MS',
        'AN',
        'NI',
        'OM',
        'PA',
        'BQ',
        'KN',
        'LC',
        'MF',
        'SA',
        'SX',
        'TL',
        'TT',
        'TC',
        'VI',
        'AE'
      ],
      isWaitEeiLoading: false
    }
  },
  async created () {
    this.recentItns = [...(await this.$store.dispatch('getRecentItns')), {
      itn: 'NO EEI 30.36'
    }, {
      itn: 'NO EEI 30.37 (a)'
    }]

    try {
      if (!this.commoditiesList || this.commoditiesList.length === 0) {
        this.$store.dispatch('getCommoditiesList', {})
      }
    } catch (error) {
      console.error('Failed to fetch commodities list:', error)
    }

    try {
      if (!this.commodityTemplates || this.commodityTemplates.length === 0) {
        this.$store.dispatch('getCommodityTemplates')
      }
    } catch (error) {
      console.error('Failed to fetch commodity templates:', error)
    }
  },
  computed: {
    isLabelServiceSupportDangerousGoods () {
      return this.internationalLabelServices.some(service => {
        const labelService = service.serviceTypes.find(type => type.value === this.shippingService)
        return labelService
          ? labelService.hasOwnProperty('isSupportDangerousGoods')
            ? labelService.isSupportDangerousGoods
            : service.isSupportDangerousGoods
          : false
      })
    },
    ...mapGetters(['commonCommodities', 'organizationCommodities', 'commoditiesList', 'commodityTemplates']),
    isCommodityUnchangeable () {
      return !!this.itn && !this.itn.includes('NO EEI 30.36') && !this.itn.includes('NO EEI 30.37')
    },
    isScheduleBReady () {
      return !!this.scheduleBMap['8517620085']
    },
    currentShippingService () {
      const activeService = this.actualService
      return this.internationalLabelServices.find(service =>
        service.serviceTypes.some(serviceType => activeService === serviceType.value)
      ) || {}
    },
    commoditiesMap () {
      const map = {}
      if (this.commoditiesList && this.commoditiesList.length > 0) {
        this.commoditiesList.forEach(item => {
          if (item.scheduleBCode) {
            map[item.scheduleBCode] = {
              uom: item.unit,
              uom1: item.unit2 || 'NULL'
            }
          }
        })
      }
      return map
    },
    scheduleBMap () {
      return this.commoditiesMap
    },
    hasCommodityQty2 () {
      return this.commodities.some(item => this.isShowQty2(item))
    },
    isSupportDangerousGoods: {
      get () {
        return !!(this.hasHazmatFeatures && this.dangerousGoods)
      },
      set (value) {
        this.isSupportHazmat = !!value
      }
    },
    toPartyIdType: {
      get () {
        return this.to.partyIdType || 'E'
      },
      set (value) {
        this.to.partyIdType = value
      }
    },
    fromPartyIdType: {
      get () {
        return this.from.partyIdType || 'E'
      },
      set (value) {
        this.from.partyIdType = value
      }
    },
    isFedexCarrier () {
      if (!this.currentShippingService?.carrier) return false
      return this.currentShippingService.carrier.toUpperCase().includes('FEDEX')
    },
    hasHazmatFeatures () {
      return true
      // return this.visibleBetaFeatures.includes('InternationalHazmat')
    },
    fromAddress () {
      const addresses = this.addresses
      return addresses
    },
    // hazmatSites () {
    //   return this.$store.getters.hazmatSites
    // },
    visibleBetaFeatures () {
      return this.$store.getters.visibleBetaFeatures
    },
    states () {
      return this.$store.getters.stateAbbrevs
    },
    addresses () {
      return this.$store.getters.tenantAddresses
    },
    packagingMap () {
      return this.$store.getters.packagingMap
    },
    labelServices () {
      return this.$store.getters.labelServices
    },
    internationalLabelServices () {
      return this.$store.getters.internationalLabelServices
    },
    systemBalance () {
      return this.$store.getters.systemBalance
    },
    actualService () {
      const actualService = this.isAutoGetRate ? this.autoGetRateShippingService : this.shippingService
      return actualService
    },
    displayRate () {
      return this.rates.find(({serviceType = '', carrier = ''}) =>
        carrier.toLowerCase() === this.actualService.toLowerCase() ||
        serviceType.toLowerCase() === this.actualService.toLowerCase() ||
        (this.actualService === 'FEDEX_GROUND' && serviceType === 'GROUND_HOME_DELIVERY')
      ) || {}
    },
    limitMultipleShipping () {
      if (this.packages.reduce((acc, pkg) => acc + pkg.qty, 0) === 1) return (v) => v <= 5 || this.$t('limitedLabelNum', { num: 5 })
      if (this.actualService !== 'USPS') {
        return (v) => v <= 1 || this.$t('multipleShippingAreOnlySupportedForUsps')
      }
      return (v) => v <= 5 || this.$t('limitedLabelNum', { num: 5 })
    },
    isMeasurementMetric () {
      return !!this.$store.getters.isMeasurementMetric
    },
    googleMapDisabled () {
      return !(
        this.to && (
          this.to.address1 &&
          this.to.city &&
          this.to.state &&
          this.to.zipCode
        )
      )
    },
    countryCodeArray () {
      return this.$store.getters.countryCodeArray
    },
    unitOfMeasures () {
      return this.$store.getters.unitOfMeasures
    },
    licenseExceptionSymbols () {
      return this.$store.getters.licenseExceptionSymbols
    },
    mergedCommoditiesList () {
      const customOption = {
        scheduleBDescription: 'Commodity Desc',
        description: 'Commodity Desc',
        scheduleBCode: '',
        harmonizedCode: '',
        origin: 'C',
        countryOfOrigin: 'US',
        unit: '',
        unit2: '',
        unitOfMeasure: '',
        category: '',
        _isCustom: true
      }

      if (this.commoditiesList && this.commoditiesList.length > 0) {
        const mappedList = this.commoditiesList.map(item => {
          const origin = item.origin
          let countryOfOrigin = 'US'
          if (origin === 'D') {
            countryOfOrigin = 'US'
          } else if (origin === 'F') {
            countryOfOrigin = item.countryCode || 'CN'
          }
          return {
            scheduleBDescription: item.itemDesc || item.commodityDetail || '',
            description: item.itemDesc || item.commodityDetail || '',
            scheduleBCode: item.scheduleBCode,
            harmonizedCode: item.scheduleBCode,
            origin: origin,
            countryOfOrigin: countryOfOrigin,
            unit: item.unit,
            unit2: item.unit2,
            unitOfMeasure: item.unit,
            category: item.category
          }
        })
        return [customOption, ...mappedList]
      }
      return this.organizationCommodities || []
    },
    countryOfOrigins () {
      return this.$store.getters.countryOfOrigins
    },
    upsUnitesList () {
      return Object.entries(this.upsUnitsMap).map(([abbr]) => {
        return {text: abbr, key: abbr}
      })
    },
    upsUnitsMap () {
      return {
        'BA': 'Barrel',
        'BE': 'Bundle',
        'BG': 'Bag',
        'BH': 'Bunch',
        'BOX': 'Box',
        'BT': 'Bolt',
        'BU': 'Butt',
        'CI': 'Canister',
        'CM': 'Centimeter',
        'CON': 'Container',
        'CR': 'Crate',
        'CS': 'Case',
        'CT': 'Carton',
        'CY': 'Cylinder',
        'DOZ': 'Dozen',
        'EA': 'Each',
        'EN': 'Envelope',
        'FT': 'Feet',
        'KG': 'Kilogram',
        'KGS': 'Kilograms',
        'LB': 'Pound',
        'LBS': 'Pounds',
        'L': 'Liter',
        'M': 'Meter',
        'NMB': 'Number',
        'PA': 'Packet',
        'PAL': 'Pallet',
        'PC': 'Piece',
        'PCS': 'Pieces',
        'PF': 'Proof Liters',
        'PKG': 'Package',
        'PR': 'Pair',
        'PRS': 'Pairs',
        'RL': 'Roll',
        'SET': 'Set',
        'SME': 'Square Meters',
        'SYD': 'Square Yards',
        'TU': 'Tube',
        'YD': 'Yard',
        'OTH': 'Other'
      }
    },
    upsUnites2Map () {
      return {
        'BBL': 'Barrels',
        'CAR': 'Carat',
        'CKG': 'Content Kilogram',
        'CM2': 'Square Centimeters',
        'CTN': 'Content Ton',
        'CUR': 'Curie',
        'CYK': 'Clean Yield Kilogram',
        'DOZ': 'Dozen',
        'DPC': 'Dozen Pieces',
        'DPR': 'Dozen Pairs',
        'FBM': 'Fiber Meter',
        'GCN': 'Gross Containers',
        'GM': 'Gram',
        'GRS': 'Gross',
        'HUN': 'Hundred',
        'KG': 'Kilogram',
        'KM3': '1,000 Cubic Meters',
        'KTS': 'Kilogram Total Sugars',
        'L': 'Liter',
        'M': 'Meter',
        'M2': 'Square Meters',
        'M3': 'Cubic Meters',
        'MC': 'Millicurie',
        'NO': 'Number',
        'PCS': 'Pieces',
        'PFL': 'Proof Liter',
        'PK': 'Pack',
        'PRS': 'Pairs',
        'RBA': 'Running Bales',
        'SQ': 'Square',
        'T': 'Ton',
        'THS': '1,000',
        'X': 'No Quantity required'
      }
    },
    upsUnites2List () {
      return Object.entries(this.upsUnites2Map).map(([abbr]) => {
        return {text: `${abbr}`, key: abbr}
      })
    },
    fedexHsCodeMap () {
      return {
        'AR': 'CARAT',
        'CM': 'CENTIMETER',
        'CFT': 'CUBIC FOOT',
        'DOZ': 'DOZEN',
        'DPR': 'DOZEN PAIR',
        'EA': 'EACH',
        'LFT': 'FOOT',
        'G': 'GRAM',
        'GR': 'GROSS',
        'KG': 'KILOGRAM',
        'LTR': 'LITER',
        'LB': 'POUND',
        'LNM': 'LINEAR METER',
        'M': 'METER',
        'M2': 'SQUARE METER (M2)',
        'M3': 'CUBIC METER',
        'MG': 'MILLIGRAM',
        'ML': 'MILLILITER',
        'NO': 'NUMBER',
        'OZ': 'OUNCE',
        'PR': 'PAIR',
        'PCS': 'PIECE',
        'SFT': 'SQUARE FOOT',
        'SYD': 'SQUARE YA,',
        'YD': 'YARD'
      }
    },
    fedexHsCodeList () {
      return Object.entries(this.fedexHsCodeMap).map(([abbr]) => {
        return {text: abbr, key: abbr}
      })
    },
    inShowChannelUnionList () {
      return this.currentShippingService.carrier?.toUpperCase()?.includes('UPS') ? this.upsUnitesList : this.fedexHsCodeList
    },
    inShowUnit2List () {
      return this.currentShippingService.carrier?.toUpperCase()?.includes('FEDEX') ? this.fedexHsCodeList : this.upsUnites2List
    },
    labelTemplates () {
      return (this.$store.getters.labelTemplates || []).filter(item => item.businessType === this.businessType)
    },
    commodityHeaders () {
      const totalCustomsValue = this.commodities.reduce((acc, item) => acc + (item.customsValue || 0), 0)
      const totalQty = this.commodities.reduce((acc, item) => acc + (item.quantity || 0), 0)
      const totalWeight = this.commodities.reduce((acc, item) => acc + (item.commodityWeight || item.weight || 0), 0)

      const hasQty2 = this.commodities.some(item => this.isShowQty2(item))

      const headers = [
        { text: this.$t('actions'), value: 'action', align: 'center', sortable: false, width: '80px' },
        { text: this.$t('commodity'), value: 'scheduleBDescription', align: 'left', sortable: false, width: '280px' },
        { text: `${this.$t('countryOfOrigin')} / ${this.$t('hsCode')}`, value: 'harmonizedCode', align: 'left', sortable: false, width: '200px' },
        { text: `${this.$t('qty')}(${totalQty})`, value: 'quantity', align: 'left', sortable: false, width: '150px' }
      ]

      if (hasQty2) {
        headers.push({ text: this.$t('qty2'), value: 'quantity2', align: 'left', sortable: false, width: '150px' })
      }

      headers.push(
        { text: `${this.$t('price')}`, value: 'price', align: 'left', sortable: false, width: '90px' },
        { text: `${this.$t('totalCustomsValue($)')}($${totalCustomsValue.toLocaleString()})`, value: 'customsValue', align: 'left', sortable: false, width: '100px' },
        { text: `${this.$t('totalWeight')}(${this.isMeasurementMetric ? 'kg' : 'Lbs'})(${totalWeight})`, value: 'commodityWeight', align: 'left', sortable: false, width: '120px' }
      )

      return headers
    },
    eeiInfoHeaders () {
      const totalCustomsValue = this.eeiInfoItems.reduce((acc, item) => acc + (item.customsValue || 0), 0)
      const totalQty = this.eeiInfoItems.reduce((acc, item) => acc + (item.quantity || 0), 0)
      const totalWeight = this.eeiInfoItems.reduce((acc, item) => acc + (item.commodityWeight || item.weight || 0), 0)
      const headers = [
        { text: this.$t('commodity'), value: 'scheduleBDescription', align: 'left', sortable: false, width: '200px' },
        { text: this.$t('scheduleBCode'), value: 'scheduleBCode', align: 'left', sortable: false, width: '200px' },
        { text: this.$t('countryOfOrigin'), value: 'countryOfOrigin', align: 'left', sortable: false, width: '200px' },
        { text: `${this.$t('qty')}(${totalQty})`, value: 'quantity', align: 'left', sortable: false, width: '150px' },
        { text: this.$t('qty2'), value: 'quantity2', align: 'left', sortable: false, width: '150px' },
        { text: `${this.$t('price')}`, value: 'price', align: 'left', sortable: false, width: '90px' },
        { text: `${this.$t('totalCustomsValue($)')}($${totalCustomsValue.toLocaleString()})`, value: 'customsValue', align: 'left', sortable: false, width: '120px' },
        { text: `${this.$t('totalWeight')}(${this.isMeasurementMetric ? 'kg' : 'Lbs'})(${totalWeight})`, value: 'commodityWeight', align: 'left', sortable: false, width: '120px' }
      ]

      return headers
    },
    eeiEditHeaders () {
      const totalCustomsValue = this.eeiEditItems.reduce((acc, item) => acc + (item.customsValue || 0), 0)
      const totalQty = this.eeiEditItems.reduce((acc, item) => acc + (item.quantity || 0), 0)
      const totalQty2 = this.eeiEditItems.reduce((acc, item) => acc + (item.quantity2 || 0), 0)
      const totalWeight = this.eeiEditItems.reduce((acc, item) => acc + (item.commodityWeight || item.weight || 0), 0)

      const headers = [
        { text: this.$t('actions'), value: 'action', align: 'center', sortable: false, width: '140px' },
        { text: this.$t('scheduleBDescription'), value: 'scheduleBDescription', align: 'left', sortable: false, width: '140px' },
        { text: this.$t('scheduleBCode'), value: 'scheduleBCode', align: 'left', sortable: false, width: '140px' },
        { text: this.$t('countryOfOrigin'), value: 'countryOfOrigin', align: 'left', sortable: false, width: '160px' },
        { text: this.$t('qty') + ` (${totalQty})`, value: 'quantity', align: 'left', sortable: false, width: '260px' },
        { text: this.$t('qty2') + ` (${totalQty2})`, value: 'quantity2', align: 'left', sortable: false, width: '260px' },
        { text: `${this.$t('price')}`, value: 'price', align: 'left', sortable: false, width: '90px' },
        { text: this.$t('totalCustomsValue($)') + ` ($${totalCustomsValue.toLocaleString()})`, value: 'customsValue', align: 'left', sortable: false, width: '120px' },
        { text: this.$t('totalWeight') + ` (${this.isMeasurementMetric ? 'kg' : 'Lbs'}) (${totalWeight})`, value: 'commodityWeight', align: 'left', sortable: false, width: '120px' }
      ]

      return headers
    },
    editingCommodityScheduleBCode () {
      if (this.editingEeiIndex !== null && this.eeiEditItems[this.editingEeiIndex]) {
        return this.eeiEditItems[this.editingEeiIndex].scheduleBCode
      }
      return ''
    }
  },
  beforeMount () {
    const {shippingService, shipmentPurpose, note, memo, signature, bookingConfirmationNumber} = this.labelInfo
    if (shippingService) {
      let actualService = ''
      for (const service of this.internationalLabelServices) {
        const serviceType = service.serviceTypes.find(serviceType => shippingService === serviceType.value)
        if (serviceType) {
          actualService = serviceType.value
          break
        }
      }
      if (actualService) {
        this.shippingService = actualService
      }
    }
    if (shipmentPurpose) this.shipmentPurpose = shipmentPurpose
    if (bookingConfirmationNumber) this.bookingConfirmationNumber = bookingConfirmationNumber
    if (note || memo || signature) Object.assign(this.noteMemoSignature, {note, memo, signature})
    // if (!this.scheduleBMap['0101210000'] && Object.keys(this.$store.getters.scheduleBMap || {}).length === 0) {
    //   this.$store.dispatch('getAESHTS').catch(error => {
    //     this.$store.dispatch('showToast', {
    //       level: 'error',
    //       info: this.$t('networkError')
    //     })
    //     throw error
    //   })
    // }
  },
  async mounted () {
    if ((this.labelInfo.packages && this.labelInfo.packages.length) || (this.labelInfo.commodities && this.labelInfo.commodities.length)) {
      this.shouldAutoApplyDefaultLabelTemplate = false
      const { dangerousGoodsInfo, commodities = [], ...infos } = this.labelInfo
      Object.assign(this, infos)
      if (commodities.length) {
        this.commodities = this.composeCommodities(commodities)
      }
      if (this.isSupportHazmat && dangerousGoodsInfo) {
        const { signatureCode, ...restDangerousGoodsInfo } = dangerousGoodsInfo
        Object.assign(this, restDangerousGoodsInfo)
        if (signatureCode && typeof signatureCode === 'string') {
          this.signatureCode = {
            downloadURL: signatureCode
          }
        } else {
          this.signatureCode = signatureCode || null
        }
      }
      this.packages = this.calAndAddQtyfromHistoryPkgs(this.packages)
    } else {
      this.tryApplyDefaultLabelTemplateOnce()
      if (this.commodities.length === 0) {
        this.addEmptyCommodity()
      }
    }
  },
  watch: {
    editingCommodityScheduleBCode (value, oldValue) {
      if (value !== oldValue && this.editingEeiIndex !== -1 && !!value) {
        const item = this.eeiEditItems[this.editingEeiIndex]
        if (item.scheduleBCode) {
          const unit = this.getUnitByCarrier(item)
          if (unit) {
            item.quantityUnits = unit || ''
          } else {
            item.quantityUnits = ''
          }
          const unit2 = this.getUnit2ByCarrier(item)
          if (unit2) {
            item.quantity2Units = unit2 || ''
          } else {
            item.quantity2Units = ''
          }
        }
      }
    },
    toTemplate () {
      this.to = cloneDeep(this.toTemplate)
    },
    fromTemplate () {
      this.from = cloneDeep(this.fromTemplate)
    },
    shippingService (value) {
      this.errorMessage = ''
      this.commodityErrorMessage = ''
      if (['USPS', 'UPS_GROUND'].includes(value)) {
        this.quantity = 1
        this.packages && this.packages.forEach(pkg => {
          pkg.insuredValue = 0
        })
      }
    },
    autoGetRateShippingService () {
      this.errorMessage = ''
      this.commodityErrorMessage = ''
    },
    'currentShippingService.carrier': {
      handler (newCarrier, oldCarrier) {
        this.errorMessage = ''
        this.commodityErrorMessage = ''
        if (!newCarrier || newCarrier === oldCarrier) return
        this.commodities.forEach((commodity) => {
          const scheduleBCode = commodity.scheduleBCode || ''

          if (commodity.isCustomCommodity || commodity.needsManualDescription) {
            commodity.unitOfMeasure = this.getUnitOfMeasure('', newCarrier)
            commodity.selectedUnit = commodity.unitOfMeasure
            return
          }

          commodity.unitOfMeasure = this.getUnitOfMeasure(scheduleBCode, newCarrier)
          commodity.selectedUnit = commodity.unitOfMeasure
        })
      },
      deep: true
    },
    parseFormAddress (value) {
      if (!value) {
        return
      }
      const lineData = value.split(/\n|\t/)
      addressArr.forEach((items, index) => {
        const data = lineData[index]?.split(',') || []
        items.forEach((item, i) => {
          let target = data[i]
          if (!target) return
          if (['state', 'countryCode'].includes(item)) target = target?.toUpperCase() || ''
          this.from[item] = target?.trim() || ''
        })
      })
    },
    errorMessage (value) {
      if (!value) {
        return null
      }
      // this.$nextTick(() => {
      //   const scrollContainer = document.querySelector('.v-card__text')
      //   if (scrollContainer) {
      //     scrollContainer.scrollTo({
      //       top: 0,
      //       behavior: 'smooth'
      //     })
      //   }
      // })
    },
    parseToAddress (value) {
      if (!value) {
        return
      }
      const lineData = value.split(/\n|\t/)
      addressArr.forEach((items, index) => {
        const data = lineData[index]?.split(',') || []
        items.forEach((item, i) => {
          let target = data[i]
          if (!target) return
          if (['state', 'countryCode'].includes(item)) target = target?.toUpperCase() || ''
          this.to[item] = target?.trim() || ''
        })
      })
    },
    labelTemplates () {
      this.tryApplyDefaultLabelTemplateOnce()
    }
  },
  methods: {
    clearDangerousGoods () {
      this.isPrintSafetyDocument = true
      this.dangerousGoods = ''
      this.signatureCode = null
    },
    applyLabelTemplate (template) {
      if (!template) return
      this.selectedLabelTemplate = template
      this.shouldAutoApplyDefaultLabelTemplate = false
      this.hasAppliedDefaultLabelTemplate = true
      if (template.from && Object.keys(template.from).length) this.from = cloneDeep(template.from)
      if (template.to && Object.keys(template.to).length) this.to = cloneDeep(template.to)
      this.selectTemplate(template)
      this.$nextTick(() => {
        const widget = this.$refs['EeiPackageWidget']
        if (widget && widget.onSelectTemplate) {
          widget.onSelectTemplate(template)
          if (template.shipDate) {
            widget.shipDate = toPickerDateString(new Date(template.shipDate))
          }
        }
        if (template.commodities && Array.isArray(template.commodities) && template.commodities.length) {
          this.$nextTick(() => {
            this.restoreCommodityUnitsFromTemplate(template.commodities)
          })
        }
      })
      if (template.commodities && Array.isArray(template.commodities) && template.commodities.length) {
        this.commodities = this.composeCommodities(template.commodities)
      }
    },
    restoreCommodityUnitsFromTemplate (commodities = []) {
      commodities.forEach((item, index) => {
        const unit = item.quantityUnits || item.unitOfMeasure || item.unit || ''
        if (!unit || !this.commodities[index]) return
        this.commodities[index].selectedUnit = unit
        this.commodities[index].unitOfMeasure = unit
      })
    },
    applyDefaultLabelTemplate () {
      const defaultTemplate = this.$store.getters.defaultLabelTemplateByType(this.businessType)
      if (defaultTemplate) {
        this.applyLabelTemplate(defaultTemplate)
      }
    },
    tryApplyDefaultLabelTemplateOnce () {
      if (!this.shouldAutoApplyDefaultLabelTemplate || this.hasAppliedDefaultLabelTemplate) return
      if ((this.labelInfo.packages && this.labelInfo.packages.length) || (this.labelInfo.commodities && this.labelInfo.commodities.length)) return
      if (this.selectedLabelTemplate) return
      const defaultTemplate = this.$store.getters.defaultLabelTemplateByType(this.businessType)
      if (!defaultTemplate) return
      this.applyLabelTemplate(defaultTemplate)
    },
    onQuantityInput (item) {
      item.customsValue = this.computeCustomsValue(item)
    },
    onPriceInput (item) {
      item.customsValue = this.computeCustomsValue(item)
    },
    computeCustomsValue (item) {
      if (!item.price || !item.quantity) return 0
      if (isNaN(item.price) || isNaN(item.quantity)) return 0
      return this.toCeilInt(Number(item.price * item.quantity))
    },
    getUnitOfEei (scheduleBCode = '') {
      let unitOfMeasure = ''
      const matchedItem = this.scheduleBMap[scheduleBCode]
      if (!matchedItem) {
        return unitOfMeasure
      }
      unitOfMeasure = matchedItem.uom
      return unitOfMeasure
    },
    getUnitByCarrier (item) {
      if (!item || !item?.scheduleBCode) return ''
      const uom = this.getUnitOfEei(item.scheduleBCode)
      if (uom) {
        const info = this.inShowUnit2List.find(item => item.key === uom)
        if (info) {
          return info.key
        }
      }
      return ''
    },
    extractEeiPayload () {
      const {
        from,
        to,
        eeiEditItems = []
      } = this

      const carriers = [
        {
          code: 'UPS',
          name: 'United Parcel Services',
          vesselName: 'UPS',
          loadingPortCode: '2006'
        },
        {
          code: 'FDX',
          name: 'Fedex express',
          vesselName: 'FEDEX',
          loadingPortCode: '2006'
        }
      ]

      const {
        shipDate,
        carrier: carrierCode
      } = this.$refs['EeiPackageWidget'].$$extractData()
      const carrier = carriers.find(item => carrierCode.toUpperCase().includes(item.vesselName)) || {}
      let {name, ...fromRest} = from
      let {address1, address2, ...rest} = to

      const payload = {
        from: {
          ...fromRest,
          partyIdType: fromRest.partyIdType || 'E',
          company: fromRest.company || fromRest.fullName || ''
        },
        to: {
          ...rest,
          partyIdType: '',
          address1,
          address2: address2 || '',
          company: rest.company || rest.fullName || ''
        },
        note: this.labelNote || '',
        commodities: eeiEditItems.map(item => {
          const {commodityWeight, ...rest} = item
          const matchedItem = this.scheduleBMap[item.scheduleBCode]

          rest.unitOfMeasure = item.quantityUnits || ''

          if (item.quantity2 && item.quantity2 > 0) {
            rest.unitOfMeasure2 = rest.quantity2Units = this.scheduleBMap[item.scheduleBCode].uom1 || item.quantity2Units || (matchedItem && matchedItem.uom1 !== 'NULL' ? matchedItem.uom1 : '')
          }
          rest.exportInformationCode = 'OS'
          rest.licenseExceptionSymbol = 'C33'
          return {commodityWeight: commodityWeight, ...rest}
        }),
        carrier,
        onboardDate: shipDate
      }
      return payload
    },
    getUnit2ByCarrier (item) {
      if (!item || !item?.scheduleBCode) return ''
      const uom1 = this.isShowQty2(item) ? this.scheduleBMap[item.scheduleBCode].uom1 : ''
      if (uom1) {
        const info = this.inShowChannelUnionList.find(item => item.key === uom1)
        if (info) {
          return info.key
        }
      }
      return ''
    },
    getEeiByItnError (error) {
      this.errorMessage = error.data ? error.data.message : error.message
      this.isSubmitEEILoading = false
      this.isWaitEeiLoading = false
    },
    getEeiByItn (data) {
      if (data && data.status === 'ready') {
        const {onboardDate, itn} = data
        if (onboardDate) {
          this.$refs['EeiPackageWidget'].shipDate = onboardDate
        }
        this.itn = itn
        if (this.recentItns.some(item => item === itn)) {
          this.recentItns.splice(this.recentItns.indexOf(itn), 1)
        }
        this.recentItns.unshift(data)
        this.$store.dispatch('showToast', {
          level: 'success',
          info: `${this.$t('eeiCreatedSuccessfully')}: ${itn}`
        })
        this.isSubmitEEILoading = false
        this.isWaitEeiLoading = false
      }
    },
    async submitEEI () {
      try {
        const valid = this.$refs['formPopup'].validate()
        if (!valid) {
          return Promise.reject(Error(this.$t('dataMissing')))
        }
        const payload = this.extractEeiPayload()
        if (!this.order) {
          delete payload.orderKey
        }
        const requestId = getRandomIdByTime(3)
        this.errorMessage = ''
        if (!payload.commodities.length) throw Error('Please add commodity before submit.')
        this.isSubmitEEILoading = true
        await this.$store.dispatch('processEei', {
          ...payload,
          requestId,
          type: 'create'
        })
          .catch(error => {
            if (error.errCode === 'endpoint-request-timed-out') {
              this.errorMessage = 'Endpoint request timed out. Please retry.'
            } else {
              this.errorMessage = error.data ? error.data.message : error.message
              if ((this.errorMessage?.includes('500') || this.errorMessage?.includes('Internal Server Error'))) {
                this.errorMessage = 'Server error occurred. Please retry.'
              }
            }
            throw error
          })
        this.isWaitEeiLoading = true
        await this.$store.dispatch('subscriptionEeiByItn', {itn: requestId, cbFunc: this.getEeiByItn, errorFunc: this.getEeiByItnError})
        this.$store.dispatch('showToast', {
          level: 'success',
          info: this.$t('pleaseWait30Seconds')
        })
      } catch (error) {
        this.isSubmitEEILoading = false
        this.isWaitEeiLoading = false
        throw error
      }
    },
    companyNameValidator (value) {
      if (!this.isEeiMode) return true
      return this.fieldIsRequired('companyName')(value)
    },
    partyIdValidator (value) {
      if (!this.isEeiMode) return true
      if (!value) return this.fieldIsRequired('EIN/SSN')(value)
      if (!/^\d{9}$/.test(value)) {
        return this.$t('fieldMustBe9Digits')
      }
      return true
    },
    priceValidator (value) {
      if (!value) return this.fieldIsRequired('price')(value)
      if (isNaN(value) || Number(value) <= 0) {
        return this.$t('price') + ' must be greater than 0'
      }
      return true
    },
    commodityWeightValidator (value) {
      if (!value) return this.fieldIsRequired('totalWeight')(value)
      if (isNaN(value) || Number(value) <= 0) {
        return this.$t('totalWeight') + ' must be greater than 0'
      }
      return true
    },
    deleteEeiItem (index) {
      this.eeiEditItems.splice(index, 1)
    },
    addEeiItem () {
      this.eeiEditItems.push({
        scheduleBDescription: '',
        scheduleBCode: '',
        countryOfOrigin: 'D',
        quantity: 1,
        quantityUnits: '',
        quantity2: 0,
        price: 0,
        quantity2Units: '',
        customsValue: 0,
        commodityWeight: 0
      })
    },
    async checkSubmitEei () {
      this.isEeiMode = true
      if (this.isAutoGetRate && this.autoGetRateShippingService && this.$refs['EeiPackageWidget']) {
        this.$refs['EeiPackageWidget'].shippingService = this.autoGetRateShippingService
        this.shippingService = this.autoGetRateShippingService
      }
      await this.$nextTick()
      const valid = this.$refs['formPopup'].validate()
      if (!valid) {
        this.$nextTick(() => {
          this.isEeiMode = false
        })
        throw Error(this.$t('dataMissing'))
      }
      const {
        carrier: carrierCode
      } = this.$refs['EeiPackageWidget'].$$extractData()

      const eeiLimit = this.getEeiDescriptionLimit(carrierCode)
      if (!carrierCode && !this.currentShippingService?.carrier && !this.displayRate?.carrier) {
        this.$nextTick(() => {
          this.isEeiMode = false
        })
        this.errorMessage = this.$t('shippingServiceIsRequired')
        this.$store.dispatch('showToast', {
          level: 'error',
          info: this.$t('shippingServiceIsRequired')
        })
        throw Error(this.$t('shippingServiceIsRequired'))
      }

      const hasTooLongDesc = this.commodities.some(item => {
        const desc = (item.scheduleBDescription || item.description || '').trim()
        return desc.length > eeiLimit
      })
      if (hasTooLongDesc) {
        this.$nextTick(() => {
          this.isEeiMode = false
        })
        const message = this.$t('fieldCharLimit', { fieldName: this.$t('description'), size: eeiLimit })
        this.errorMessage = message
        this.commodityErrorMessage = message
        this.$store.dispatch('showToast', {
          level: 'error',
          info: message
        })
        throw Error(message)
      }
      return true
    },
    async showEEIPopup () {
      if (!await this.checkSubmitEei()) return
      this.errorMessage = ''
      this.editingEeiIndex = -1

      this.eeiEditItems = this.commodities.map(item => {
        const scheduleBCode = item.scheduleBCode || ''
        const matchedItem = this.scheduleBMap[scheduleBCode]
        const quantityUnits = matchedItem?.uom && matchedItem.uom !== 'NULL'
          ? matchedItem.uom
          : this.getUnitOfMeasure(scheduleBCode, this.currentShippingService.carrier)

        const hasQty2 = this.isShowQty2(item)
        const quantity2 = hasQty2 ? (item.quantity2 || 0) : 0
        const quantity2Units = hasQty2 ? (matchedItem?.uom1 || item.quantity2Units || '') : ''

        return {
          scheduleBDescription: item.scheduleBDescription,
          scheduleBCode: scheduleBCode,
          countryOfOrigin: this.getCountryOfOriginOnEei(item),
          quantity: item.quantity,
          quantityUnits: quantityUnits,
          price: item.price,
          quantity2: quantity2,
          quantity2Units: quantity2Units,
          customsValue: item.customsValue,
          commodityWeight: item.commodityWeight
        }
      })

      await this.submitEEI()
    },
    getCountryOfOriginOnEei (item) {
      if (!item || !item.countryOfOrigin) return 'D'
      return item.countryOfOrigin === 'US' ? 'D' : 'F'
    },
    getEeiDescriptionLimit (carrier = '') {
      let carrierStr = carrier
      if (!carrierStr && this.displayRate) {
        carrierStr = this.displayRate.carrier || ''
      }
      if (!carrierStr && this.currentShippingService) {
        carrierStr = this.currentShippingService.carrier || ''
      }
      if (!carrierStr && this.$refs['EeiPackageWidget']) {
        try {
          carrierStr = this.$refs['EeiPackageWidget'].$$extractData()?.carrier || ''
        } catch (e) {
          carrierStr = ''
        }
      }
      const upper = String(carrierStr).toUpperCase()
      if (upper.includes('UPS')) return 35
      if (upper.includes('FEDEX')) return 45
      return 45
    },
    getQtySuffix (item) {
      if (!this.scheduleBMap[item.scheduleBCode]) return ''
      const unit = this.getUnitOfMeasure(item.scheduleBCode, this.currentShippingService.carrier)
      return this.inShowChannelUnionList.find(item => item.key === unit)?.key || unit
    },
    isUnitValid (item) {
      const unit = this.getQtySuffix(item)
      return unit && this.inShowChannelUnionList.find(item => item.key === unit)
    },
    isShowQty2 (item) {
      return this.scheduleBMap[item.scheduleBCode] && this.scheduleBMap[item.scheduleBCode].uom1 !== 'NULL'
    },
    isHsCodeRequired (item) {
      // HS Code is not required for custom commodities
      if (item && item.isCustomCommodity) return false

      return this.currentShippingService &&
        this.currentShippingService.carrier &&
        this.currentShippingService.carrier?.toUpperCase()?.includes('FEDEX')
    },
    onHarmonizedCodeInput (item) {
      item.harmonizedCode = item.harmonizedCode
    },
    getCountryOfOriginFromItem (origin, countryOfOrigin) {
      if (origin === 'D') return 'US'
      if (origin === 'F') return countryOfOrigin || 'CN'
      return countryOfOrigin || 'US'
    },
    getCommodityUpdates (selectedItem, isCommodityUnchangeable = false) {
      if (selectedItem === null || selectedItem === '') {
        return {
          scheduleBCode: '',
          selectedCommodity: null,
          exportInformationCode: 'OS',
          countryOfOrigin: 'US',
          licenseExceptionSymbol: 'C33',
          isCustomCommodity: false,
          needsManualDescription: false,
          scheduleBDescription: ''
        }
      }

      if (typeof selectedItem !== 'object') {
        return {}
      }

      const item = selectedItem

      if (isCommodityUnchangeable) {
        const description = item.scheduleBDescription || item.description || ''
        return {
          scheduleBCode: item.scheduleBCode || '',
          countryOfOrigin: item.countryOfOrigin || 'US',
          scheduleBDescription: description,
          unitOfMeasure: item.unitOfMeasure || item.unit || this.getUnitOfMeasure(item.scheduleBCode, this.currentShippingService.carrier)
        }
      }

      if (item._isCustom) {
        return {
          scheduleBDescription: '',
          scheduleBCode: '',
          selectedCommodity: item,
          countryOfOrigin: 'US',
          isCustomCommodity: true,
          needsManualDescription: false,
          unitOfMeasure: '',
          selectedUnit: ''
        }
      }

      const {
        scheduleBDescription,
        description,
        scheduleBCode,
        origin,
        countryOfOrigin,
        unit2
      } = item

      const fullDescription = scheduleBDescription || description || ''

      const updates = {
        scheduleBDescription: fullDescription,
        needsManualDescription: false,
        scheduleBCode: scheduleBCode || '',
        selectedCommodity: item,
        isCustomCommodity: false,
        countryOfOrigin: this.getCountryOfOriginFromItem(origin, countryOfOrigin)
      }

      const unitOfMeasure = this.getUnitOfMeasure(scheduleBCode, this.currentShippingService.carrier)
      updates.unitOfMeasure = unitOfMeasure
      updates.selectedUnit = unitOfMeasure

      if (unit2) {
        updates.quantity2Units = unit2
      }

      return updates
    },
    getQuantitySuffix (item) {
      if (!item || !item.scheduleBCode) return ''

      const normalizedCode = item.scheduleBCode.replace('.', '')
      if (!this.scheduleBMap[normalizedCode]) return ''

      const uom = this.scheduleBMap[normalizedCode].uom
      if (uom === 'NO') {
        if (this.currentShippingService && this.currentShippingService.carrier) {
          const carrier = this.currentShippingService.carrier?.trim()?.toUpperCase()
          if (carrier.includes('UPS')) return 'PCS'
          if (carrier.includes('FEDEX')) return 'NO'
        }
        return 'NUMBER'
      }

      return uom
    },
    getCommodityUnitItems (item = {}) {
      const currentUnit = item.selectedUnit || item.unitOfMeasure || ''
      if (!currentUnit) return this.inShowChannelUnionList
      if (this.inShowChannelUnionList.find(option => option.key === currentUnit)) {
        return this.inShowChannelUnionList
      }
      return [{ text: currentUnit, key: currentUnit }, ...this.inShowChannelUnionList]
    },

    toggleParseAddress (name, textName, addressInfo) {
      const value = this[name]
      if (!value) {
        this[name] = true
        let address = ''
        addressArr.forEach(items => {
          items.forEach((item, index) => {
            if (address && ![items.length, 0].includes(index)) address += ','
            address += addressInfo[item] || ''
          })
          address += '\n'
        })
        if (!address.replace(/,/g, '').trim()) return
        this[textName] = address
      } else {
        this[name] = false
      }
    },
    changeShippingService () {
      this.errorMessage = ''
      this.commodityErrorMessage = ''
    },
    switchMoreRateServiceType (item) {
      if (this.isAutoGetRate) {
        this.autoGetRateShippingService = item.serviceType
      }
      this.shippingService = item.serviceType
      if (this.$refs['EeiPackageWidget']) {
        this.$refs['EeiPackageWidget'].shippingService = item.serviceType
        this.$refs['EeiPackageWidget'].shipmentPurpose = ''
      }
      this.errorMessage = ''
      this.commodityErrorMessage = ''
    },
    toCeilInt (value) {
      if (isNaN(value)) return 0
      return parseInt(Math.ceil(value))
    },
    composeCommodities (commodities = []) {
      const items = commodities.map((item) => {
        const {
          harmonizedCode,
          scheduleBDescription,
          countryOfOrigin,
          unitOfMeasure,
          exportInformationCode,
          weight,
          customsValue,
          quantity,
          licenseExceptionSymbol,
          commodityDescription,
          quantityUnits,
          commodityWeight,
          scheduleBCode,
          commodity,
          description,
          unit,
          price = 0
        } = item

        // Need to refactor. temporary use Map fields handle...

        const normalizedScheduleBCode = scheduleBCode || harmonizedCode || ''
        const normalizedDescription = commodityDescription || description || commodity || scheduleBDescription || ''
        const normalizedScheduleBDescription = scheduleBDescription || commodity || description || ''
        const normalizedUnit = quantityUnits || unitOfMeasure || unit || ''
        const totalValue = customsValue
        // Dual use price
        let signPrice = price
        if (!price) {
          signPrice = this.toCeilInt(totalValue / quantity)
        }
        const origin = (countryOfOrigin === 'D' || countryOfOrigin === 'US') ? 'US' : 'CN'
        const commodityInfo = {
          licenseExceptionSymbol,
          exportInformationCode,
          scheduleBDescription: normalizedScheduleBDescription,
          countryOfOrigin: origin,
          commodityDescription: normalizedDescription,
          harmonizedCode: harmonizedCode || normalizedScheduleBCode,
          customsValue: totalValue,
          weight: commodityWeight || weight || 0,
          unitOfMeasure: normalizedUnit,
          quantity2: quantity || 1,
          selectedUnit: normalizedUnit,
          quantity: quantity || 1,
          commodityWeight: commodityWeight || weight || 0,
          scheduleBCode: normalizedScheduleBCode,
          price: signPrice || 0
        }
        if (this.scheduleBMap[normalizedScheduleBCode]) {
          const matchedCommodity = this.mergedCommoditiesList.find(c => c.scheduleBCode === normalizedScheduleBCode)
          if (matchedCommodity) {
            commodityInfo.selectedCommodity = matchedCommodity
            Object.assign(commodityInfo, this.getCommodityUpdates(matchedCommodity, this.isCommodityUnchangeable), {
              countryOfOrigin: origin
            })
            commodityInfo.scheduleBDescription = commodityInfo.commodityDescription || normalizedScheduleBDescription || matchedCommodity.scheduleBDescription || ''
            this.$nextTick(() => {
              commodityInfo.selectedUnit = normalizedUnit || commodityInfo.selectedUnit || ''
            })
          }
        } else {
          commodityInfo.selectedCommodity = this.mergedCommoditiesList.find(c => c._isCustom)
          Object.assign(commodityInfo, this.getCommodityUpdates(commodityInfo.selectedCommodity, this.isCommodityUnchangeable), {
            countryOfOrigin: origin
          })
          commodityInfo.scheduleBDescription = commodityInfo.commodityDescription || normalizedScheduleBDescription || commodityInfo.selectedCommodity.scheduleBDescription || ''
          this.$nextTick(() => {
            commodityInfo.selectedUnit = normalizedUnit || commodityInfo.selectedUnit || ''
          })
        }

        if (this.isCommodityUnchangeable) {
          commodityInfo.scheduleBDescription = normalizedScheduleBDescription || commodityInfo.scheduleBDescription
          commodityInfo.selectedUnit = normalizedUnit || commodityInfo.selectedUnit
          commodityInfo.unitOfMeasure = commodityInfo.selectedUnit
        }
        return commodityInfo
      })
      this.composeEeiItems(items)
      return items
    },
    composeEeiItems (commodities = []) {
      this.eeiInfoItems = commodities.map(item => {
        const totalValue = item.customsValue
        let signPrice = item.price
        if (!item.price) {
          signPrice = this.toCeilInt(totalValue / item.quantity)
        }
        const eei = {
          scheduleBDescription: item.scheduleBDescription,
          scheduleBCode: item.scheduleBCode,
          countryOfOrigin: item.countryOfOrigin,
          quantity: item.quantity,
          quantityUnits: item.quantityUnits || item.unitOfMeasure,
          quantity2: item.quantity2 || 0,
          quantity2Units: item.quantity2Units,
          customsValue: totalValue,
          price: signPrice || 0,
          commodityWeight: item.commodityWeight
        }
        return eei
      })
    },
    getUnitOfMeasure (scheduleBCode = '', carrier = '') {
      let unitOfMeasure = ''
      carrier = carrier.trim().toUpperCase()
      const matchedItem = this.scheduleBMap[scheduleBCode]
      if (!matchedItem) return unitOfMeasure

      if (matchedItem.uom === 'NO') {
        unitOfMeasure = (carrier.includes('UPS') && 'PCS') || (carrier.includes('FEDEX') && 'NO') || matchedItem.uom
      } else {
        unitOfMeasure = matchedItem.uom
      }
      const unit = this.inShowChannelUnionList.find(item => item.key === unitOfMeasure)
      return unit ? unit.key : unitOfMeasure
    },
    selectTemplate (e) {
      const {
        dangerousGoods,
        dryIceDetail = {},
        signatureCode
      } = e
      const params = {
        dangerousGoods,
        dryIceDetail
      }
      if (signatureCode && typeof signatureCode === 'string') {
        params.signatureCode = {
          downloadURL: signatureCode
        }
      } else {
        params.signatureCode = signatureCode || null
      }
      Object.assign(this, params)
      if (this.$refs['EeiPackageWidget']) {
        if (e.shipDate) {
          this.$refs['EeiPackageWidget'].shipDate = e.shipDate
        }
        if (e.labelStockType) {
          this.$refs['EeiPackageWidget'].labelStockType = e.labelStockType
        }
      }
    },
    clearFromTemplate (value) {
      // reset from
      if (!value) return
      this.fromTemplate = {}
    },
    toMoney,
    async getAddressFromItn () {
      const {from = {}, to = {}, commodities = [], onboardDate} = await this.$store.dispatch('getAddressFromItn', {itn: this.itn})
      if (onboardDate) {
        Object.assign(this, {
          from,
          to,
          commodities: this.composeCommodities(commodities)
        })
        this.$refs['EeiPackageWidget'].shipDate = onboardDate
      }
    },
    createAddress (addresses) {
      return this.$store.dispatch('labelCreateAddress', {addresses})
    },
    extractPayload (isGetRate = false) {
      const {
        from,
        to,
        order,
        isUseCompanySignatureOnFile,
        isOriginatorShipperDiff,
        isRecipientNotImporter,
        termsOfSale,
        isUseCompanyLetterheadOnFile,
        isProFormaInvoice,
        isCommercialInvoice,
        itn,
        commodities = [],
        isSupportDangerousGoods,
        dangerousGoods,
        dryIceDetail
      } = this

      const {
        packages,
        shipDate,
        shippingService,
        signature,
        memo,
        note,
        bookingConfirmationNumber,
        purpose = '',
        carrier,
        carriers,
        labelStockType
      } = this.$refs['EeiPackageWidget'].$$extractData(isGetRate)

      const { totalWeight } = packages.reduce((res, pkg) => {
        res.totalWeight += pkg.weight
        return res
      }, {
        totalWeight: 0
      })
      if (this.commodities.reduce((sum, item) => sum + item.commodityWeight, 0) > totalWeight) {
        throw Error('The total weight of the commodities cannot exceed the total weight of the package.')
      }

      const [serviceType = '', channel = ''] = (shippingService || '').split(' - ')

      let {name, ...fromRest} = from
      let {address1, address2, ...rest} = to

      this.validDangerousGoodsInfo()

      if (!this.currentShippingService.isSupportFromExt) {
        delete fromRest.extension
      }
      if (!this.currentShippingService.isSupportToExt) {
        delete rest.extension
      }
      fromRest.company = fromRest.company || fromRest.fullName || ''
      fromRest.partyIdType = fromRest.partyIdType || 'E'
      const payload = {
        packages: packages.map(pkg => {
          const {_key, ...rest} = pkg
          return rest
        }),
        from: fromRest,
        to: {
          ...rest,
          address1,
          address2: address2 || '',
          partyIdType: rest.partyIdType || 'E',
          company: rest.company || rest.fullName || ''
        },
        shipDate,
        serviceType,
        channel,
        shippingService,
        signature,
        dutiesPayor: this.dutiesPayor,
        memo,
        note: note || this.labelNote,
        orderKey: order ? order._key : '',
        carrier,
        isMeasurementMetric: this.isMeasurementMetric,
        isUseCompanySignatureOnFile,
        isOriginatorShipperDiff,
        isRecipientNotImporter,
        termsOfSale,
        isUseCompanyLetterheadOnFile,
        isProFormaInvoice,
        isCommercialInvoice,
        labelStockType,
        itn,
        commodities: commodities.map((item, index) => {
          const {commodityWeight, weight, isLoading, needsManualDescription, selectedCommodity, ...rest} = item
          if (this.isCommodityUnchangeable) {
            if (this.eeiInfoItems.length > 0) {
              const eeiItem = this.eeiInfoItems[index]
              if (eeiItem) {
                // EEI countryOfOrigin: D = Domestic (US), F = Foreign (non-US)
                if (eeiItem.countryOfOrigin === 'D') {
                  if (item.countryOfOrigin !== 'US') {
                    throw Error(`When EEI country of origin is ${this.$t('domesticOrigin')}, all commodities must have country of origin as US.`)
                  }
                } else if (eeiItem.countryOfOrigin === 'F') {
                  if (item.countryOfOrigin === 'US') {
                    throw Error(`When EEI country of origin is ${this.$t('foreignOrigin')}, commodities cannot have country of origin as US.`)
                  }
                }
              }
            }
            rest.quantity2 = item.quantity || item.quantity2 || 0
            // rest.commodityDescription = item.scheduleBDescription || ''
            // rest.countryOfOrigin = item.countryOfOrigin || 'US'
            // rest.harmonizedCode = item.harmonizedCode || ''
            // rest.commodityQuantity = item.quantity || 1
            // rest.commodityQuantityUnits = item.quantityUnits || item.unitOfMeasure || ''
            // const eeiItem = this.eeiInfoItems[index]
            // if (eeiItem && !isGetRate) {
            //   rest.scheduleBDescription = eeiItem.scheduleBDescription || ''
            //   rest.scheduleBCode = eeiItem.scheduleBCode || ''
            //   rest.exportInformationCode = eeiItem.exportInformationCode || ''
            //   rest.licenseExceptionSymbol = eeiItem.licenseExceptionSymbol || ''
            //   rest.quantity = eeiItem.quantity || 1
            //   rest.quantityUnits = eeiItem.quantityUnits || ''
            //   rest.customsValue = eeiItem.customsValue || 0
            //   rest.commodityWeight = eeiItem.commodityWeight || 0
            //   if (eeiItem.quantity2Units) {
            //     rest.quantity2 = eeiItem.quantity2 || 1
            //     rest.quantity2Units = eeiItem.quantity2Units || ''
            //   }
            // }
          }
          rest.unitOfMeasure = item.selectedUnit || this.getUnitOfMeasure(item.scheduleBCode, carrier) || item.unitOfMeasure || ''
          rest.commodityDescription = item.scheduleBDescription || ''
          return {weight: commodityWeight, ...rest}
        }),
        bookingConfirmationNumber,
        purpose,
        isSupportHazmat: isSupportDangerousGoods,
        carriers
      }
      if (isSupportDangerousGoods && dangerousGoods === 'DRY_ICE') {
        Object.assign(payload, {
          dryIceDetail,
          dangerousGoods
        })
      }

      if (isSupportDangerousGoods) {
        if (dangerousGoods === 'LITHIUM_BATTERY') {
          if (this.isPrintSafetyDocument && !this.signatureCode) {
            throw Error('Please select signature file for dangerous goods.')
          }

          if (!payload.packages.some(item => item.lithiumBatteryOptions && item.lithiumBatteryOptions.length > 0)) {
            throw Error('Please select lithium battery options for at least one package.')
          }
          Object.assign(payload, {
            isSupportDangerousGoods,
            dangerousGoods,
            signatureCode: this.isPrintSafetyDocument && this.signatureCode ? this.signatureCode.downloadURL : null,
            isPrintSafetyDocument: this.isPrintSafetyDocument || false,
            packages: packages.map(item => {
              return {
                ...item,
                isLithiumBattery: item.lithiumBatteryOptions && item.lithiumBatteryOptions.length > 0,
                lithiumBatteryOptions: item.lithiumBatteryOptions || []
              }
            })
          })
        } else if (dangerousGoods === 'DRY_ICE') {
          Object.assign(payload, {
            dryIceDetail,
            dangerousGoods,
            packages: packages.map(item => {
              return {
                ...item,
                isLithiumBattery: false,
                lithiumBatteryOptions: []
              }
            })
          })
        } else {
          Object.assign(payload, {
            isSupportDangerousGoods,
            dangerousGoods,
            packages: packages.map(item => {
              return {
                ...item,
                isLithiumBattery: false,
                lithiumBatteryOptions: []
              }
            })
          })
        }
      } else {
        payload.packages = packages.map(item => {
          return {
            ...item,
            isLithiumBattery: false,
            lithiumBatteryOptions: []
          }
        })
      }
      return payload
    },
    async getRate () {
      this.isGetRateAction = true
      this.rates = []
      await this.$nextTick()
      try {
        if (this.packages.reduce((acc, pkg) => acc + pkg.qty, 0) > 25) {
          throw Error('Package quantity are limited to 25.')
        }
        this.moreRates = []
        const valid = this.$refs['formPopup'].validate()
        if (!valid) {
          return Promise.reject(Error(this.$t('dataMissing')))
        }
        this.errorMessage = ''
        this.deleteWarningMessage('address-ambiguous', 'recommend-address')
        let payload = this.extractPayload(true)
        const isAutoGetRate = this.isAutoGetRate
        const signature = payload.signature || 'NO_SIGNATURE_REQUIRED'
        if (signature === 'NO_SIGNATURE_REQUIRED' && payload.packages.some(pkg => +pkg.insuredValue)) {
          throw Error(`No signature doesn't support declare value for international shipments.`)
        }
        this.systemBalance.discount && (payload.discount = this.systemBalance.discount)
        this.isLoadingRates = true
        if (isAutoGetRate) {
          payload.shippingLabelType = 'export'
        }
        this.$store.dispatch('getRates', payload)
          .then(rtn => {
            if (rtn.data.notMatch) {
              this.setWarningMessages('address-ambiguous', this.$t('notMatch'))
            } else if (rtn.data.isCleansed) {
              let {
                address1,
                city,
                state,
                zipCode
              } = rtn.data
              this.setWarningMessages('recommend-address', this.$t('recommendedRecipientAddress', { address: address1, city, state, zipCode }))
            }
            if (rtn.data.moreRates) {
              const {estimatedDelivery: estDelivery = null} = rtn.data
              this.rates = rtn.data.moreRates.map(({serviceType, serviceDescription, amountDetails, estimatedDelivery = estDelivery, originBaseCharge, message, errCode, carrier}) => {
                if (errCode || message) {
                  return {
                    carrier,
                    serviceType,
                    serviceDescription: serviceDescription,
                    errCode,
                    message
                  }
                }
                const {postageAmount, ...surcharges} = amountDetails
                const surcharge = Object.values(surcharges).reduce((a, b) => toMoney(a + b), 0)
                return {
                  carrier: rtn.data.carrier,
                  serviceType,
                  serviceDescription,
                  rate: postageAmount,
                  hasResidentialCheck: true,
                  isResidential: rtn.data.isResidential,
                  surcharge,
                  total: toMoney(surcharge + postageAmount),
                  estimatedDelivery,
                  originBaseCharge: originBaseCharge && Number(originBaseCharge)
                }
              })
            } else if (rtn.data.totalAmount) { // non-fedex
              const {postageAmount, ...surcharges} = rtn.data.amountDetails
              const surcharge = Object.values(surcharges).reduce((a, b) => toMoney(a + b), 0)
              const {carrier = 'usps', serviceType, serviceDescription, estimatedDelivery, originBaseCharge} = rtn.data
              this.rates = [{
                carrier,
                serviceType,
                serviceDescription,
                estimatedDelivery,
                hasResidentialCheck: false,
                rate: postageAmount,
                surcharge,
                originBaseCharge: originBaseCharge && Number(originBaseCharge),
                total: toMoney(surcharge + postageAmount)
              }]
            }
            if (isAutoGetRate) {
              this.switchShippingService(this.rates[0])
            }
          })
          .catch(error => {
            this.errorMessage = error.message
          })
          .finally(() => {
            this.isLoadingRates = false
          })
      } catch (e) {
        this.errorMessage = e.message
      }
    },
    switchShippingService ({ serviceType }) {
      this.autoGetRateShippingService = serviceType
      this.shippingService = serviceType
      if (this.$refs['EeiPackageWidget']) {
        this.$refs['EeiPackageWidget'].shippingService = serviceType
      }
      this.errorMessage = ''
      this.commodityErrorMessage = ''
    },
    async onSubmitted () {
      try {
        if (this.isWaitEeiLoading || this.isSubmitEEILoading) {
          throw Error('Please wait for EEI loading to complete.')
        }
        this.isGetRateAction = false
        await this.$nextTick()
        const { pkgQty } = this.packages.reduce((res, pkg) => {
          res.pkgQty += pkg.qty
          return res
        }, {
          pkgQty: 0
        })
        const valid = this.$refs['formPopup'].validate()
        if (!valid) {
          return Promise.reject(Error(this.$t('dataMissing')))
        }
        const commodityValid = this.$refs['commodityForm'].validate()
        if (!commodityValid) {
          return Promise.reject(Error(this.$t('dataMissing')))
        }
        // if (!this.$refs['formPopup'].validate()) return
        if (pkgQty > 25) {
          throw Error('Package quantity are limited to 25.')
        }
        if (['USPS', 'UPS_GROUND'].includes(this.shippingService) && pkgQty > 1) {
          throw Error('Selected provider does not support multiple packages.')
        }
        if (this.commodities.reduce((sum, item) => sum + item.customsValue, 0) > 2500 && !this.itn) {
          throw Error('ITN is required when shipment customs value is over $2500.')
        }

        if (this.isAutoGetRate) {
          this.$refs['EeiPackageWidget'].shippingService = this.autoGetRateShippingService
        }
        const payload = this.extractPayload()

        const signature = payload.signature || 'NO_SIGNATURE_REQUIRED'
        if (signature === 'NO_SIGNATURE_REQUIRED' && payload.packages.some(pkg => +pkg.insuredValue)) {
          throw Error(`No signature doesn't support declare value for international shipments.`)
        }

        if (!this.order) {
          delete payload.orderKey
        }
        let {isSaveFrom, isSaveTo, to, from} = this
        let {isAmazon: tempFlag, ...toRest} = to
        let {isAmazon, ...fromRest} = from
        let addressesToCreate = []
        isSaveTo && addressesToCreate.push(toRest)
        isSaveFrom && addressesToCreate.push(fromRest)
        addressesToCreate.length && this.createAddress(addressesToCreate)
        this.errorMessage = ''
        const label = {
          ...payload,
          isMeasurementMetric: this.isMeasurementMetric,
          requestId: this.requestIdCache || this.idGenerator(1)[0]
        }
        if (this.isEnabledETD && this.isFedexCarrier) {
          label.isEnabledETD = true
          const country = String(to.countryCode || '').trim().toUpperCase()
          if (this.notAllowedCountries.includes(country)) {
            throw Error(this.$t('etdCountryNotSupported', { country }))
          }
        }
        return this.$store.dispatch('createInternationalLabel', label)
          .then(rtn => {
            this.requestIdCache = ''
            const {successLabels, errorLabels} = rtn
            this.$emit('submitted', successLabels
              .map(item => {
                return {
                  ...item,
                  createTime: new Date(),
                  lastModifiedTime: new Date()
                }
              }))
            if (errorLabels.length > 0) {
              throw Error(errorLabels[0].message || `${successLabels.length} label(s) created successfully. ${errorLabels.length} failed. You can try recreating the rest of labels.`)
            }
          })
          .catch(error => {
            if (error.message === 'request-label-error') {
              this.errorMessage = this.$t('failedToRequestForLabel')
            } else if (error.message === 'endpoint-request-timed-out') {
              this.errorMessage = this.$t('labelEndpointRequestTimedOut')
              this.requestIdCache = label.requestId
            } else if (error.message === 'Package 1 - Special service SIGNATURE_OPTION is invalid.') {
              this.errorMessage = this.$t('specialServiceInvalid')
            } else {
              this.errorMessage = error.data ? error.data.message : error.message
            }
            throw new Error(this.errorMessage)
          })
      } catch (error) {
        this.errorMessage = error.message
        throw error
      }
    },
    deleteAddress (address) {
      if (!confirm(this.$t('confirmDelete', { name: 'address' }))) return Promise.resolve()
      return this.$store.dispatch('labelDeleteAddress', address)
        .then(() => {
          if (this.from.siteName === address.siteName) {
            this.from = {}
          }
          if (this.to.siteName === address.siteName) {
            this.to = {}
          }
        })
    },
    setWarningMessages (key, value) {
      this.warningMessages[key] = value
    },
    deleteWarningMessage (...keys) {
      keys.forEach(key => {
        delete this.warningMessages[key]
      })
    },
    clearWarningMessages () {
      this.warningMessages = {}
    },
    formatEstDeliveryDate (str) {
      return (str === 'N/A' || !str) ? 'N/A' : this.toDateYYYYMMDD((new Date(str)))
    },
    goToGoogleMapLink () {
      gotoGoogleMap(this.to)
    },
    onSelectItn (item) {
      this.itn = item.itn
      this.menuItn = false
    },
    async getEeiStatus () {
      await Promise.all(this.recentItns.map(async item => {
        if (item.itn) return 'success'
        const {itn} = await this.$store.dispatch('getEeiStatus', item)
        item.itn = itn
      }))
      return 'success'
    },
    onSelectCommonCommodityByEei (data) {
      if (!data) return

      const selectedItem = typeof data === 'string'
        ? this.commonCommodities.find(item => item.description === data)
        : data

      if (selectedItem) {
        const newCommodity = {
          exportInformationCode: 'OS',
          licenseExceptionSymbol: 'C33',
          countryOfOrigin: this.getCountryOfOriginOnEei(selectedItem),
          scheduleBDescription: selectedItem.description,
          scheduleBCode: selectedItem.code || '',
          customsValue: 0,
          commodityWeight: 0,
          quantity: 1,
          quantityUnits: '',
          quantity2: 0,
          quantity2Units: ''
        }

        const unit = this.getUnitByCarrier(newCommodity)
        if (unit) {
          newCommodity.quantityUnits = unit
        }
        const unit2 = this.getUnit2ByCarrier(newCommodity)
        if (unit2) {
          newCommodity.quantity2Units = unit2
        }
        this.eeiEditItems.push(newCommodity)
      }
    },
    validDangerousGoodsInfo () {
      const {
        isSupportDangerousGoods,
        shippingService,
        internationalLabelServices
      } = this
      if (!isSupportDangerousGoods) return
      // const isPackageGreaterThanTwo = packages.length === 1
      //   ? packages[0].qty === 1
      //   : false
      // if (!isPackageGreaterThanTwo) throw Error(this.$t('hazmatPackageError'))

      const isSupportHazmatService = internationalLabelServices.some(service => {
        const serviceType = service.serviceTypes.find(serviceType => shippingService === serviceType.value)
        return serviceType && serviceType.isSupportDangerousGoods
      })
      if (!isSupportHazmatService) throw Error(this.$t('shippingServiceNotSupportDangerousGoods'))
    },
    addEmptyCommodity () {
      this.commodityErrorMessage = ''

      const customCommodityOption = {
        scheduleBDescription: 'Commodity Desc',
        description: 'Commodity Desc',
        scheduleBCode: '',
        harmonizedCode: '',
        origin: 'C',
        countryOfOrigin: 'US',
        unit: '',
        unit2: '',
        unitOfMeasure: '',
        category: '',
        _isCustom: true
      }

      this.commodities.push({
        exportInformationCode: 'OS',
        licenseExceptionSymbol: 'C33',
        countryOfOrigin: 'US',
        scheduleBCode: '',
        customsValue: 0,
        commodityWeight: 0,
        price: 0,
        quantity: 1,
        scheduleBDescription: '',
        harmonizedCode: '',
        selectedCommodity: customCommodityOption,
        isCustomCommodity: true,
        needsManualDescription: false
      })
    },

    deleteCommodity (index) {
      if (this.commodities.length > 1) {
        this.commodities.splice(index, 1)
      } else {
        this.commodityErrorMessage = this.$t('atLeastOneCommodity')
      }
    },

    validateHsCode (value) {
      if (!value) return true

      if (value.length < 6 || value.length > 15 || isNaN(+value)) {
        return this.$t('hsCodeValidation')
      }

      if (this.currentShippingService &&
          this.currentShippingService.carrier &&
          this.currentShippingService.carrier.toUpperCase().includes('FEDEX')) {
        if (value.length < 6) {
          return this.$t('fedexRequires6DigitHsCode')
        }
      }

      return true
    },
    checkCommodityProfile (item, isEei = false) {
      if (!item.scheduleBDescription?.trim()) {
        this.commodityErrorMessage = this.$t('commodityDescriptionIsMissing')
        throw Error(this.$t('commodityDescriptionIsMissing'))
      }
      const eeiLimit = this.getEeiDescriptionLimit()
      if (isEei && item.scheduleBDescription?.trim().length > eeiLimit) {
        this.commodityErrorMessage = this.$t('fieldCharLimit', { fieldName: this.$t('description'), size: eeiLimit })
        throw Error(this.commodityErrorMessage)
      }
      if (!isEei && item.scheduleBDescription?.trim().length > 450) {
        this.commodityErrorMessage = this.$t('commodityDescriptionIsTooLong')
        throw Error(this.$t('commodityDescriptionIsTooLong'))
      }
      if (!item.isCustomCommodity) {
        if (isEei) {
          if (!item.scheduleBCode) {
            this.commodityErrorMessage = this.$t('scheduleBCodeIsMissing')
            throw Error(this.$t('scheduleBCodeIsMissing'))
          }
          if (item.scheduleBCode.length !== 10 || isNaN(+item.scheduleBCode)) {
            this.commodityErrorMessage = this.$t('scheduleBCodeValidation')
            throw Error(this.$t('scheduleBCodeValidation'))
          }
        } else {
          if (!item.harmonizedCode) {
            this.commodityErrorMessage = this.$t('harmonizedCodeIsMissing')
            throw Error(this.$t('harmonizedCodeIsMissing'))
          }
          if (item.harmonizedCode.length < 6 || item.harmonizedCode.length > 10 || isNaN(+item.harmonizedCode)) {
            this.commodityErrorMessage = this.$t('hsCodeValidation')
            throw Error(this.$t('hsCodeValidation'))
          }
        }
      }
      if (!item.countryOfOrigin) {
        this.commodityErrorMessage = this.$t('countryOfOriginValidation')
        throw Error(this.$t('countryOfOriginValidation'))
      }
      // const showQty2 = this.isShowQty2(item)
      // if (showQty2 && !item.quantity2) {
      //   this.commodityErrorMessage = this.$t('quantity2IsMissing')
      //   throw Error(this.$t('quantity2IsMissing'))
      // }
      return true
    },
    async saveCommodityProfile (item, isEei = false) {
      if (!this.checkCommodityProfile(item, isEei)) return Promise.reject(Error(this.commodityErrorMessage))
      if (item.isLoading) return
      this.$set(item, 'isLoading', true)
      this.commodityToSave = {...item}
      this.commodityErrorMessage = ''
      const {quantity, isLoading, selectedCommodity, quantity2, commodityWeight, customsValue, quantityUnits, quantity2Units, price, ...rest} = this.commodityToSave
      const scheduleBDescription = item.scheduleBDescription.trim()
      const payload = {
        scheduleBDescription,
        profileName: scheduleBDescription,
        exportInformationCode: rest.exportInformationCode || 'OS',
        licenseExceptionSymbol: rest.licenseExceptionSymbol || 'C33',
        countryOfOrigin: rest.countryOfOrigin || 'US',
        harmonizedCode: rest.harmonizedCode || rest.scheduleBCode || '',
        scheduleBCode: rest.scheduleBCode || '',
        price: price || 0
      }
      try {
        let target = await this.$store.dispatch('getCommodityKey', {keyword: payload.profileName, scheduleBDescription: payload.scheduleBDescription})
        if (target) {
          await this.$store.dispatch('addCommodity', {...payload, isUpdate: true, key: target})
        } else {
          await this.$store.dispatch('addCommodity', payload)
        }

        this.$store.dispatch('showToast', {info: this.$t('commodityProfileSaved'), level: 'success'})

        this.profileNameDialog = false

        return Promise.resolve()
      } catch (error) {
        this.commodityErrorMessage = error.message || this.$t('saveFailed')
        return Promise.reject(error)
      } finally {
        this.$set(item, 'isLoading', false)
      }
    },

    async onSelectCommonCommodity (data) {
      if (!data) return
      const selectedItem = typeof data === 'string'
        ? this.commonCommodities.find(item => item.description === data)
        : data

      if (selectedItem) {
        const newCommodity = {
          exportInformationCode: 'OS',
          licenseExceptionSymbol: 'C33',
          countryOfOrigin: 'US',
          scheduleBDescription: selectedItem.description,
          harmonizedCode: selectedItem.hsCode || selectedItem.code || '',
          customsValue: 0,
          commodityWeight: 0,
          price: 0,
          quantity: 1,
          unitOfMeasure: this.getUnitOfMeasure(selectedItem.code, this.currentShippingService.carrier)
        }

        this.commodities.push(newCommodity)
      }
    },
    onSelectCommodityTemplate (template) {
      if (!template) return

      const templateData = typeof template === 'string'
        ? this.commodityTemplates.find(item => item.name === template)
        : template

      if (templateData && templateData.commodities && templateData.commodities.length > 0) {
        this.commodities = templateData.commodities.map(item => {
          const matchedCommodity = this.mergedCommoditiesList.find(c => c.scheduleBCode === item.scheduleBCode)
          return {
            ...item,
            selectedCommodity: matchedCommodity || this.mergedCommoditiesList.find(c => c._isCustom),
            customsValue: (item.quantity || 0) * (item.price || 0)
          }
        })
      }
    },
    saveCommodityTemplate () {
      const templateName = this.newTemplateName

      if (!templateName || !templateName.trim()) {
        this.$store.dispatch('showToast', {info: this.$t('pleaseEnterTemplateName'), level: 'error'})
        return
      }

      const trimmedName = templateName.trim()

      const isDuplicate = this.commodityTemplates.some(template => template.name === trimmedName)
      if (isDuplicate) {
        this.$store.dispatch('showToast', {info: this.$t('templateNameAlreadyExists'), level: 'error'})
        return
      }

      if (!this.commodities || this.commodities.length === 0) {
        this.$store.dispatch('showToast', {info: this.$t('pleaseAddCommoditiesFirst'), level: 'error'})
        return
      }

      this.isSavingTemplate = true

      const payload = {
        name: trimmedName,
        description: trimmedName,
        commodities: this.commodities.map(item => ({
          scheduleBCode: item.scheduleBCode || '',
          scheduleBDescription: item.scheduleBDescription || '',
          harmonizedCode: item.harmonizedCode || '',
          countryOfOrigin: item.countryOfOrigin || 'US',
          quantity: item.quantity || 0,
          selectedUnit: item.selectedUnit || item.unitOfMeasure || '',
          quantity2: null,
          quantity2Units: '',
          price: item.price || 0,
          customsValue: item.customsValue || 0,
          commodityWeight: item.commodityWeight || 0
        }))
      }

      this.$store.dispatch('updateCommodityTemplate', payload).then(() => {
        this.$store.dispatch('showToast', {info: this.$t('templateSavedSuccessfully'), level: 'success'})
        this.newTemplateName = ''
      }).catch(error => {
        this.$store.dispatch('showToast', {info: error.message || this.$t('failedToSaveTemplate'), level: 'error'})
        throw error
      }).finally(() => {
        this.isSavingTemplate = false
      })
    },
    clearCommodity (index) {
      this.commodities[index].scheduleBDescription = ''
      this.commodities[index].harmonizedCode = ''
      this.commodities[index].scheduleBCode = ''
      this.commodities[index].price = 0
      this.commodities[index].unitOfMeasure = ''
      this.commodities[index].selectedCommodity = null
    },
    onComboboxChangeByCommodities (selectedItem, index) {
      this.commodityErrorMessage = ''

      const updates = this.getCommodityUpdates(selectedItem, this.isCommodityUnchangeable)
      Object.assign(this.commodities[index], updates)
    },
    editEeiRow (index, event) {
      if (this.editingEeiIndex === index) return

      this.editingEeiIndex = index

      if (event) event.stopPropagation()
    },
    editRow (index, event) {
      if (this.editingRowIndex === index) return

      this.editingRowIndex = index

      if (event) event.stopPropagation()
    },
    onRowMouseLeave (event) {
      if (event && event.relatedTarget) {
        if (event.currentTarget.contains(event.relatedTarget)) {
          return
        }
        const selectMenus = document.querySelectorAll('.v-select-list, .v-menu__content')
        for (let menu of selectMenus) {
          if (menu.contains(event.relatedTarget)) {
            return
          }
        }
      }
      setTimeout(() => {
        const activeElement = document.activeElement
        if (activeElement && (
          activeElement.closest('.qty_unit') ||
          activeElement.closest('.v-select-list') ||
          activeElement.closest('.v-menu__content')
        )) {
          return
        }
        this.editingRowIndex = -1
        this.editingEeiIndex = -1
      }, 100)
    }
  },
  props: {
    value: Boolean,
    idGenerator: Function,
    initTemplate: {
      type: Object,
      default: () => {
        return {}
      }
    },
    onlyOneLabel: Boolean,
    order: Object,
    labelInfo: Object,
    businessType: {
      type: String,
      default: 'export'
    }
  }
}
</script>

<style scoped>
.checkbox {
  margin-bottom: 0px;
  position: relative;
  top: 12px;
}

.etd-checkbox-container {
  flex-wrap: nowrap;
  gap: 0;
}

.etd-checkbox-container .v-input {
  flex-grow: 0;
  margin-right: 0;
  padding-right: 0;
}

.etd-checkbox-container .v-input__control {
  min-width: auto;
}

.etd-checkbox-container .v-input__slot {
  margin-bottom: 0;
  margin-right: 0;
}

.etd-checkbox-container .v-messages {
  display: none;
}

.etd-checkbox-container .v-input--checkbox {
  margin-right: 0;
}

.etd-checkbox-container .v-input--checkbox .v-input__control .v-input__slot .v-input--selection-controls__input {
  margin-right: 4px;
}
.checkbox >>> .v-label {
  font-size: 10px !important;
  top: 0px !important;
}

.compact {
  padding: 4px !important;
  zoom: 0.8;
  margin-bottom: 12px !important;
}

.compact .v-container {
  padding: 4px !important;
}

.compact .v-card {
  margin-bottom: 4px !important;
}

.compact .v-card__text {
  padding: 8px 16px !important;
}

.compact .v-layout {
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}

.compact .v-text-field {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
}

.compact .v-select {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.compact .v-input {
  margin-top: 8px !important;
}
.compact .v-input >>> .v-label {
  font-size: 14px !important;
  top: 14px;
}

.compact .v-data-table {
  margin-top: 4px !important;
}

.table-item {
  margin: 4px !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.qty_unit_filed /deep/ .v-input__append-outer {
  margin-top: -8px !important;
}
.qty_unit_filed .v-input {
  margin-top: 0px;
}
.qty_unit_filed .qty_unit {
  margin: 0;
  padding: 0;
}

.qty_unit_filed .qty_unit /deep/ label::after {
  content: "";
}

.commodity-row {
  cursor: pointer;
  transition: all 0.2s;
}

.loading {
  transform-origin: 50% 50%;
  animation: pullOrderLoading 3s infinite linear;
  -moz-animation: pullOrderLoading 3s infinite linear;
  -webkit-animation: pullOrderLoading 3s infinite linear;
  -o-animation: pullOrderLoading 3s infinite linear;
}
@keyframes pullOrderLoading {
  0% {
    -webkit-transform: rotate(0);
  }

  50% {
    -webkit-transform: rotate(180deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LabelCreateInternationalPopup.vue